import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';
import { Modal, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '../../../hoc/withLocalization';
import { TasksWidget } from '../../../components/GenericForm/Widgets/TasksWidget';
import { Accordion, AccordionItem } from '../../../components/Accordion/Accordion';
import InputTime from '../../../components/GenericForm/Widgets/InputTime';
import TimelogArray from '../../../components/TimelogArray/TimelogArray';
import DynamicList from '../../../components/DynamicList/DynamicList';
import { AttachmentsWidget } from '../../../components/GenericForm/Widgets/AttachmentsWidget';
import Signature from '../../../components/Signature/Signature';
import Button from '../../../components/CustomButton/CustomButton.jsx';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { MembersWidget } from '../../../components/GenericForm/Widgets/UsersWidget';
import TimePickerInput from '../../../components/TimePicker';
import { ProjectsWidget } from '../../../components/GenericForm/Widgets/ProjectsWidget';
import UserPromptModal from '../../../components/GenericModal/userPromptModal/index.js';

//elements
import LoadingSpinner from '../../../elements/LoadingSpinner';
import { Input, Textarea, NumberInput } from '../../../elements/Input';
import Select from '../../../elements/Select.js';

//configs
import { getUploadedFileURL } from '~/library/config';

//utils
import customerFeature from '~/utils/customerFeature';
import {
    getUserExtraPayments, getCompanyShiftDetails,
    getOvertimeMode, overtimeModes, renderCompanyShiftDetails,
    getShiftTotalTimeBetweenStartAndEnd, getOvertimeTypeArray,
    getOvertimeObject, mergeExtraOvertimeTypes
} from '../../../utils/commonMethods';
import { getMinutesFromTimeInput, minutesToTimeInput } from '../../../utils/timeCalc';
import { MANUAL_EXTRA_PAYMENT_TYPES } from '../../../utils/constants';
import { longDateFormat, distanceUnitType, timeFormat, shortDateFormat } from '../../../utils/dateFormat';

//assests
import distanceIcon from '../../../assets/img/distance.svg';
import PlayStart from '../../../assets/img/PlayStart.svg';
import FinishMap from '../../../assets/img/FinishMap.svg';
import manuallyIcon from '../../../assets/img/manuallyIcon.svg';
import startIcon from '../../../assets/img/startIcon.svg';
import endIcon from '../../../assets/img/endIcon.svg';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';

//styles
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../../styles/css/timelogs.css';
class TimelogsForm extends Component {
    constructor(props) {
        super(props);
        this.hasCompanyShifts = props?.commonStore?.config?.client?.allow_company_shifts;
        this.isOvertimeAutomaticMode = !this.hasCompanyShifts && props?.commonStore?.config?.client?.data?.basicRules?.overtimeAutomaticMode;
        this.timesheetOvertimeTypesArray = [];
        this.state = {
            isqucikChecklist: false,
            isDateChange: false,
            automaticOvertimeObject: {},
            previousProjectId: null,
            isEditingCompanyShift: false,
            // Finish-time additional payments popup (backend-driven, after finish)
            finishUserPrompts: [],
            userPromptModal: {
                source: '',
                header: '',
                showModal: false,
                sourceInfo: {},
                actionMethods: {}
            }
        }
        this.props.timelogStore.updateLoaderState(true);
    }

    componentDidMount() {
        this.loadData();
    }

    prepareOvertimeArray() {
        const { timelogStore, commonStore } = this.props;
        const { currentEntity } = timelogStore;
        if (this.hasCompanyShifts) {
            const companyShift = getCompanyShiftDetails(commonStore.config, currentEntity.company_shift_id, minutesToTimeInput);
            const overtimeTypes = companyShift?.overtimes?.length && companyShift.overtimes.map(ot => ({ ...ot.Overtime_Setting }));
            this.timesheetOvertimeTypesArray = mergeExtraOvertimeTypes(
                getOvertimeTypeArray(overtimeTypes, true, false, null),
                [currentEntity.data?.overtimes],
                commonStore.config?.overtimes
            );
        } else if (this.isOvertimeAutomaticMode) {
            this.timesheetOvertimeTypesArray = getOvertimeTypeArray([], false, true, commonStore.config.client.data.basicRules.overtimeCalcRules);
        }
        else {
            this.timesheetOvertimeTypesArray = getOvertimeTypeArray(commonStore.config.client.data.basicRules.overtime_types, false, false, null);
        }
    }

    componentDidUpdate(previousProps) {
        if (previousProps.router?.location?.pathname !== this.props.router?.location?.pathname) {
            if (this.props.router.params.id) {
                this.props.timelogStore.load(this.props.router.params.id).then((timelog) => {
                    this.handleChange('for_date', timelog.timelog.for_date, true);
                });
            }
        }
    }

    handleQuickChecklistModalClose = (isInjury) => {
        this.reportInjuryDuringWork(isInjury)
        this.setState({ isqucikChecklist: false });
        this.getBack();
    };

    handleMandatoryTimelogModalClose = (isTypeSaved = false) => {
        this.handleCloseUserPromptModal();
        if (isTypeSaved) this.props.router.navigate(`/admin/timelogs/${this.props.timelogStore.currentEntity.id}`);
    };

    reportInjuryDuringWork = async (isInjury) => {
        const { timelogStore, commonStore, t } = this.props;
        const { currentEntity } = timelogStore;
        await timelogStore.reportInjury(currentEntity, isInjury).then(result => {
            if (!result || (Array.isArray(result) ? !result[0]?.id : !result.id)) {
                commonStore.addNotification(t(result.message || 'Error'), null, 'error');
            }
            if (result.data.isInjury) {
                commonStore.addNotification(t('Very sorry to know about your injury, PM and management has been informed'), null, 'success');
            }
        });
    }

    checkIfOvertimeEditable(client, currentUser, currentEntity) {
        const { data: clientData } = client;
        if (this.isOvertimeAutomaticMode) {
            return { addEdit: false, message: 'Overtime is being calculated automatically' };
        }
        else if (this.hasCompanyShifts) {
            if (currentEntity.is_manually_managed) {
                if (clientData.loginRules.autoTimelogs === 'gps') {
                    if (clientData.loginRules.pmManagesOvertime) {
                        return (currentUser && currentUser.user_type !== 'member') ?
                            { addEdit: true, message: 'Add Mandatory Overtime' } :
                            { addEdit: false, message: 'Only PM/Admin can manage overtime' };
                    } else {
                        return ((currentUser && currentEntity && currentUser.id === currentEntity.user_id) || currentUser.user_type === 'admin') ?
                            { addEdit: true, message: 'Add Mandatory Overtime' } :
                            { addEdit: false, message: 'PM cannot manage overtime' };
                    }
                }
                return { addEdit: true, message: 'Add Mandatory Overtime' };
            }
            return { addEdit: false, message: 'Overtime is being calculated automatically' };
        }
        else if (currentEntity && currentEntity.status === "draft") {
            return { addEdit: false, message: 'Cannot add overtime while timesheet in draft' };
        }
        else if (clientData && clientData.loginRules && clientData.loginRules.autoTimelogs && clientData.loginRules.autoTimelogs === 'gps') {
            if (clientData.loginRules.pmManagesOvertime) {
                return (currentUser && currentUser.user_type !== 'member') ?
                    { addEdit: true, message: 'Add Overtime' } :
                    { addEdit: false, message: 'Only PM/Admin can manage overtime' };
            } else {
                return ((currentUser && currentEntity && currentUser.id === currentEntity.user_id) || currentUser.user_type === 'admin') ?
                    { addEdit: true, message: 'Add Overtime' } :
                    { addEdit: false, message: 'PM cannot manage overtime' };
            }
        }
        else return { addEdit: true, message: 'Add Overtime' };
    }

    visualState() {
        const { timelogStore, userStore, commonStore } = this.props;
        const { user_type, id: userId, data: userData } = userStore.currentUser;
        const { config } = commonStore;
        const { currentEntity } = timelogStore;

        const manualDisabled = !!userData.disable_manual_log;
        const pauseButtonEnabled = !!userData.enable_pause_button;
        const gpsEnabled = customerFeature('gps_enabled');
        const allowEditing = (user_type === 'pm' || user_type === 'admin')
            && customerFeature('pm_allow_editing_all') && !customerFeature('timelog_hide_names');
        const showStatus = user_type === 'pm' && customerFeature('allow_accepting')
            && currentEntity.task_id && currentEntity.status !== 'draft';
        const allowSave = currentEntity.status === 'draft' || currentEntity.user_id === userId || allowEditing;
        const normalEditing = currentEntity.task_id && currentEntity.tracker_status !== 'na';
        const showStartButtons = currentEntity.status === 'draft' && currentEntity.task_id && currentEntity.tracker_status === 'na';
        const isManualMode = normalEditing && currentEntity.tracker_status === 'manual';
        const isTrackingMode = normalEditing && currentEntity.status === 'draft' && currentEntity.tracker_status !== 'manual';

        //adding condition for autoShiftplan//
        const isSystemEntry = (currentEntity.gps_data && currentEntity.gps_data.systemEntry) ? currentEntity.gps_data.systemEntry : false;
        const trackerIsRunning = currentEntity.status === 'draft'
            && (currentEntity.tracker_status === 'started' || currentEntity.tracker_status === 'break' || isSystemEntry);
        const allowTimeEditing = !isTrackingMode;
        const showFinishButtons = trackerIsRunning;
        const { addEdit: isOvertimeEditable, message: overtimeTooltipMessage } = this.checkIfOvertimeEditable(config.client, userStore.currentUser, currentEntity);

        return {
            gpsEnabled,
            allowEditing,
            allowSave,
            showStatus,
            normalEditing,
            showStartButtons,
            showFinishButtons,
            isManualMode,
            isTrackingMode,
            trackerIsRunning,
            allowTimeEditing,
            manualDisabled,
            pauseButtonEnabled,
            isOvertimeEditable,
            overtimeTooltipMessage
        };
    }

    timeAction = async (act) => {
        const { timelogStore, projectStore, taskStore } = this.props;
        const { currentEntity } = timelogStore;
        const { shiftProjectId, shiftTaskId, shiftProjectName, shiftTaskName, shiftTaskNumber, shiftProjectNumber } = this.props.router?.location?.state || {}
        try {
            if (act === 'start') {
                try {
                    const response = await timelogStore.startByButton(currentEntity);
                    timelogStore.setLastInteractedId(response.timelog.id);

                    if (shiftProjectId && shiftProjectName) {
                        projectStore.prependProjectToLookup({ id: shiftProjectId, name: shiftProjectName, project_number: shiftProjectNumber });
                    }
                    if (shiftTaskId && shiftTaskName) {
                        taskStore.prependTaskToLookup({ id: shiftTaskId, name: shiftTaskName, task_number: shiftTaskNumber });
                    }

                    const mandatoryOvertimeFlexitime = !response?.timelog?.is_manually_managed && response.userPrompts.find(ele => ele.source === 'mandatoryOvertimeFlexitime')
                    if (mandatoryOvertimeFlexitime?.showModal) {
                        this.setState({
                            userPromptModal: {
                                ...mandatoryOvertimeFlexitime,
                                actionMethods: {
                                    handleSubmitMandatoryTimelog: (data) => this.handleSubmitMandatoryTimelog(data),
                                    handleMandatoryTimelogModalClose: (istypeSaved) => this.handleMandatoryTimelogModalClose(istypeSaved),
                                    handleCloseUserPromptModal: (istypeSaved) => this.handleMandatoryTimelogModalClose(istypeSaved)
                                }
                            }
                        });
                    }
                    return response;
                }
                catch (err) {
                    const errBody = err?.response?.body;

                    const cancelAbsenceVacation = errBody.userPrompts.find(ele => ele.source === 'cancelAbsenceVacation');
                    const mandatoryPrompt = errBody.userPrompts.find(ele => ele.source === 'mandatoryOvertimeFlexitime');

                    if (cancelAbsenceVacation?.showModal) {
                        this.setState({
                            userPromptModal: {
                                ...cancelAbsenceVacation,
                                actionMethods: {
                                    handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                                    handleAbsenceVacationCancelAndProceed: () => this.handleAbsenceVacationCancelAndProceed(cancelAbsenceVacation.sourceInfo),
                                    handleAbsenceVacationCheckAndCancelManually: () => this.handleAbsenceVacationCheckAndCancelManually(cancelAbsenceVacation.sourceInfo, currentEntity.for_date),
                                    handleAbsenceWithMandatoryOvertimeFlexitime: () => this.handleRegisterWithMandatory(mandatoryPrompt),
                                }
                            }
                        });
                    }

                    const intersection = errBody.userPrompts.find(ele => ele.source === 'intersection')
                    if (intersection?.showModal) {
                        this.setState({
                            userPromptModal: {
                                ...intersection, actionMethods: {
                                    handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                                    handleRegisterWithMandatory: () => this.handleManageTimesheetManually(false, false, true),
                                    handleAbsenceWithMandatoryOvertimeFlexitime: () => this.handleRegisterWithMandatory(mandatoryPrompt),
                                }
                            }
                        });
                    }
                }
            }
            else if (act === 'finish') {
                await timelogStore.finishByButton(currentEntity, currentEntity).then(result => {
                    const resetAutoApprovedLog = result.userPrompts?.find(ele => ele.source === 'resetAutoApprovedLog');
                    if (resetAutoApprovedLog?.showModal) {
                        this.setState({ userPromptModal: { ...resetAutoApprovedLog, actionMethods: { handleConfirmResetAutoApprovedLog: () => this.confirmResetAndProceed(() => this.timeAction('finish')), handleCloseUserPromptModal: this.handleCloseUserPromptModal } } });
                        return;
                    }
                    const approvedWeeklyOvertime = result.userPrompts?.find(ele => ele.source === 'approvedWeeklyOvertime');
                    if (approvedWeeklyOvertime?.showModal) {
                        this.setState({ userPromptModal: { ...approvedWeeklyOvertime, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal, handleResetApprovedWeeklyOvertime: () => this.handleResetApprovedWeeklyOvertime(approvedWeeklyOvertime.sourceInfo.approvedWeeklyOvertime.approvedTimesheets) } } });
                        return;
                    }
                    const timesheetAdjustment = result.userPrompts.find(ele => ele.source === 'timesheetAdjustmentByAbsence')
                    const timesheetAdjustmentByTimesheet = result.userPrompts.find(ele => ele.source === 'timesheetAdjustmentByTimesheet')
                    const overtimeComment = result.userPrompts.find(ele => ele.source === 'overtimeComment')
                    const isTimelogApproved = result.timelog && result.timelog.status === 'approved';
                    if (timesheetAdjustmentByTimesheet?.showModal) {
                        this.setState({ userPromptModal: { ...timesheetAdjustmentByTimesheet, actionMethods: { handleCloseUserPromptModal: () => this.handleCloseAbsenceTimesheetAdjustmentModal(isTimelogApproved) } } });
                    } else if (timesheetAdjustment?.showModal) {
                        this.setState({ userPromptModal: { ...timesheetAdjustment, actionMethods: { handleCloseUserPromptModal: () => this.handleCloseAbsenceTimesheetAdjustmentModal(isTimelogApproved), adjustTimesheetForAbsence: this.adjustTimesheetForAbsence } } });
                    } else if (overtimeComment?.showModal) {
                        this.setState({
                            userPromptModal: {
                                ...overtimeComment,
                                actionMethods: {
                                    handleSaveOvertimeComment: (comment) => this.saveOvertimeComment(result.timelog.id, comment, () => this.showAdditionalPaymentPromptOrTimebank(result.userPrompts)),
                                    handleCloseUserPromptModal: () => {
                                        this.handleCloseUserPromptModal();
                                        this.showAdditionalPaymentPromptOrTimebank(result.userPrompts);
                                    },
                                }
                            }
                        });
                    } else {
                        this.showAdditionalPaymentPromptOrTimebank(result.userPrompts);
                    }
                });
            }
            else if (act === 'break') {
                const isPaused = currentEntity.tracker_status === 'break';
                await timelogStore.breakByButton(currentEntity.id, isPaused ? 'stop' : 'start', false);
                this.loadData();
            }
            else if (act === 'manual') {
                timelogStore.setManualDefaults();
            }
        } catch (err) {
            console.error({ err });
        }
    };

    // Backend-driven additional payments popup (shown after a tracked timesheet is finished).
    // "Update timesheet" stores the entered hours and re-saves; then the normal post-finish flow continues.
    handleUpdateTimesheetWithExtraPayment = async (enteredMap, rules) => {
        const { timelogStore } = this.props;
        const prompts = this.state.finishUserPrompts || [];
        (rules || []).forEach(rule => {
            const entered = enteredMap[rule.code];
            // Points are entered as a number; other manual types as hh:mm. handleChangeExtraPayments
            // stores points as entered (0-1.0) and hh:mm as minutes, based on the rule type.
            const isPoints = rule.type === 'manual_point_amount';
            const hasValue = isPoints ? (Number(entered) > 0) : (entered && getMinutesFromTimeInput(entered) > 0);
            if (hasValue) {
                timelogStore.handleChangeExtraPayments({ code: rule.code, name: rule.name, amount: rule.amount, payrollWageType: rule.payrollWageType, extraPaymentType: { value: rule.type || 'manual_hourly_amount' } }, entered);
            }
        });
        this.handleCloseUserPromptModal();
        try {
            await timelogStore.save();
        } catch (e) {
            console.error(e);
        }
        this.loadAutoFlexitimeTimeBankIfAny(prompts);
    };

    handleCancelAdditionalPaymentPrompt = () => {
        const prompts = this.state.finishUserPrompts || [];
        this.handleCloseUserPromptModal();
        this.loadAutoFlexitimeTimeBankIfAny(prompts);
    };

    // Additional payments prompt (from finish) if any, otherwise continue to the timebank/flexitime step.
    showAdditionalPaymentPromptOrTimebank = (userPrompts) => {
        const additionalPaymentEntry = userPrompts?.find(ele => ele.source === 'additionalPaymentEntry');
        if (!additionalPaymentEntry?.showModal) return this.loadAutoFlexitimeTimeBankIfAny(userPrompts);
        const rules = additionalPaymentEntry.sourceInfo.additionalPaymentEntry.rules;
        this.setState({
            finishUserPrompts: userPrompts,
            userPromptModal: {
                ...additionalPaymentEntry,
                actionMethods: {
                    handleUpdateTimesheetWithExtraPayment: (enteredMap) => this.handleUpdateTimesheetWithExtraPayment(enteredMap, rules),
                    handleCloseUserPromptModal: this.handleCancelAdditionalPaymentPrompt,
                }
            }
        });
    };

    handleSubmitMandatoryTimelog = async (data) => {
        const { t, commonStore, timelogStore } = this.props;
        try {
            if (!data.type)
                return commonStore.addNotification(t('Please select a mandatory time type'), null, 'warning');
            if (data.type === 'overtime' && !data.overtimeCode)
                return commonStore.addNotification(t('Please select a mandatory overtime type'), null, 'warning');

            await timelogStore.startTimelogAsMandatory(timelogStore.currentEntity.id, data);
            commonStore.addNotification(t('Success'), null, 'success');
            this.handleMandatoryTimelogModalClose(true);
        } catch (error) {
            commonStore.addNotification(t(error || 'Error'), null, 'error');
        }
    }

    checkQuickQuery = () => {
        const { commonStore, t } = this.props;
        const { client } = commonStore.config;
        if (client && client.data && client.data.basicRules && client.data.basicRules.allowQucikChecklist) {
            this.setState({ isqucikChecklist: true });
        } else {
            this.getBack();
        }
    }

    handlePayALLHours = () => {
        const { timelogStore } = this.props;
        const { currentEntity } = timelogStore;
        this.handleCloseUserPromptModal();
        if (currentEntity.tracker_status !== 'manual' && currentEntity.data?.isInjury === undefined) {
            this.checkQuickQuery();
        } else {
            this.getBack();
        }
    }

    loadAutoFlexitimeTimeBankIfAny = (userPrompts) => {
        const { timelogStore } = this.props;
        const { currentEntity } = timelogStore;

        const timebankOvertime = userPrompts.find(ele => ele.source === 'timebankOvertime')
        if (timebankOvertime?.showModal) {
            this.setState({ userPromptModal: { ...timebankOvertime, actionMethods: { handleCloseUserPromptModal: this.handlePayALLHours, handlePayALLHours: this.handlePayALLHours, handleSaveToTimebank: this.handleSaveToTimebank } } });
        } else {
            if (currentEntity.tracker_status !== 'manual' && currentEntity.data?.isInjury === undefined) {
                this.checkQuickQuery();
            } else {
                this.getBack();
            }
        }
    }

    adjustTimesheetForAbsence = (time) => {
        const { commonStore, t } = this.props;
        this.handleCloseUserPromptModal();
        this.handleChange('id', null);
        this.handleChange('from', time.from);
        this.handleChange('to', time.to);
        this.handleChange('break', 0);
        this.handleChange('overtime_comment', '');
        this.handleChange('for_date', time.for_date, true);
        commonStore.addNotification(t('Time adjusted as per absence please click save to create this remaining timesheet'), null, 'info', 'top-right', 4000);
    }

    confirmResetAndProceed = async (action) => {
        const { timelogStore } = this.props;
        this.handleCloseUserPromptModal();
        timelogStore.changeEntity('confirmResetAutoApprovedLog', true);
        await action();
    }

    // The timesheet is already saved when the overtime comment is asked for, so this only
    // attaches the comment to it — `onDone` carries on with whatever the save flow was going
    // to do next (the timebank prompt or navigating back).
    saveOvertimeComment = async (id, comment, onDone) => {
        const { timelogStore } = this.props;
        try {
            await timelogStore.saveOvertimeComment(id, comment);
        } catch (err) {
            // Stay on the prompt so the comment can be corrected and saved again
            console.error({ err });
            return;
        }
        this.handleCloseUserPromptModal();
        if (onDone) onDone();
    }

    handleResetApprovedWeeklyOvertime = async (approvedTimesheets) => {
        const { timelogStore, commonStore, t } = this.props;
        try {
            await timelogStore.resetApprovedWeeklyOvertimeTimesheets(approvedTimesheets);
            this.handleCloseUserPromptModal();
            commonStore.addNotification(t('Approved timesheets have been reset successfully.'), null, 'success');
            this.loadData();
        } catch (err) {
            console.error(err);
        }
    }

    handleResetTimebankAndProceed = async (convertedOvertimeTimelog) => {
        const { timelogStore } = this.props;
        await timelogStore.deleteTimebankAllByDate({ user_id: convertedOvertimeTimelog.user_id, for_date: convertedOvertimeTimelog.for_date })
            .then(res => {
                this.props.commonStore.addNotification(this.props.t(res.message), null, 'success');
                this.handleCloseUserPromptModal();
            });
    }

    afterSave = (result, doPublish, skipCheck) => {
        const { commonStore, t, timeBankStore } = this.props;

        const resetAutoApprovedLog = result?.userPrompts?.find(ele => ele.source === 'resetAutoApprovedLog');
        if (resetAutoApprovedLog?.showModal) {
            return this.setState({
                userPromptModal: {
                    ...resetAutoApprovedLog,
                    actionMethods: {
                        handleConfirmResetAutoApprovedLog: () => this.confirmResetAndProceed(this.fullSave),
                        handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                    }
                }
            });
        }

        const convertedOvertimeConflict = result?.userPrompts?.find(ele => ele.source === 'convertedOvertimeConflict');
        if (convertedOvertimeConflict?.showModal) {
            const { convertedOvertimeTimelog } = convertedOvertimeConflict.sourceInfo.convertedOvertimeConflict;
            return this.setState({
                userPromptModal: {
                    ...convertedOvertimeConflict,
                    actionMethods: {
                        handleResetTimebankAndProceed: () => this.handleResetTimebankAndProceed(convertedOvertimeTimelog),
                        handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                    }
                }
            });
        }

        const approvedWeeklyOvertime = result?.userPrompts?.find(ele => ele.source === 'approvedWeeklyOvertime');
        if (approvedWeeklyOvertime?.showModal) {
            return this.setState({
                userPromptModal: {
                    ...approvedWeeklyOvertime,
                    actionMethods: {
                        handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                        handleResetApprovedWeeklyOvertime: () => this.handleResetApprovedWeeklyOvertime(approvedWeeklyOvertime.sourceInfo.approvedWeeklyOvertime.approvedTimesheets),
                    }
                }
            });
        }

        if (!result.timelog || (Array.isArray(result.timelog) ? !result.timelog[0]?.id : !result.timelog.id)) {

            const intersection = result.userPrompts.find(ele => ele.source === 'intersection')
            if (intersection?.showModal) {
                this.setState({ userPromptModal: { ...intersection, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal, handleRegisterWithMandatory: () => this.handleManageTimesheetManually(false, false, true) } } });
            }
            const absenceIntersection = result.userPrompts.find(ele => ele.source === 'timesheetAbsenceIntersection')
            if (absenceIntersection?.showModal) {
                this.setState({ userPromptModal: { ...absenceIntersection, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal } } });
            }
            const vacationIntersection = result.userPrompts.find(ele => ele.source === 'timesheetVacationIntersection')
            if (vacationIntersection?.showModal) {
                this.setState({ userPromptModal: { ...vacationIntersection, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal } } });
            }
            const timesheetTimesheetIntersection = result.userPrompts.find(ele => ele.source === 'timesheetTimesheetIntersection')
            if (timesheetTimesheetIntersection?.showModal) {
                this.setState({ userPromptModal: { ...timesheetTimesheetIntersection, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal } } });
            }

            return false;
        }

        this.props.timelogStore.setLastInteractedId(result.timelog.id);

        if (result?.successMsg)
            commonStore.addNotification(t(result?.successMsg), null, 'success')

        commonStore.addNotification(result.message || t('Saved'), null, 'success');

        const timesheetAdjustment = result.userPrompts.find(ele => ele.source === 'timesheetAdjustmentByAbsence')
        const overtimeComment = result.userPrompts.find(ele => ele.source === 'overtimeComment')
        const isTimelogApproved = result.timelog?.status === 'approved' || false;
        if (timesheetAdjustment?.showModal && !skipCheck?.skipAbsenceIntersectionCheck) {
            this.setState({ userPromptModal: { ...timesheetAdjustment, actionMethods: { handleCloseUserPromptModal: () => this.handleCloseAbsenceTimesheetAdjustmentModal(isTimelogApproved), adjustTimesheetForAbsence: this.adjustTimesheetForAbsence } } });
        } else if (overtimeComment?.showModal) {
            this.setState({
                userPromptModal: {
                    ...overtimeComment,
                    actionMethods: {
                        handleSaveOvertimeComment: (comment) => this.saveOvertimeComment(result.timelog.id, comment, () => this.loadAutoFlexitimeTimeBankIfAny(result.userPrompts)),
                        handleCloseUserPromptModal: () => {
                            this.handleCloseUserPromptModal();
                            this.loadAutoFlexitimeTimeBankIfAny(result.userPrompts);
                        },
                    }
                }
            });
        } else {
            this.loadAutoFlexitimeTimeBankIfAny(result.userPrompts)
        }
    };

    handleCloseAbsenceTimesheetAdjustmentModal = (isTimelogApproved = false) => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } })
        if (!isTimelogApproved) this.fullSave(true, { skipAbsenceIntersectionCheck: true })
        else this.getBack();
    }

    handleCloseUserPromptModal = () => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } })
    }

    getBack() {
        const { page, lastInteractedId } = this.props.router.location.state || {};
        this.props.router.navigate("/admin/timelogs", { state: { page: page || 0, lastInteractedId } });
    }

    handleMandatoryCalls = async (saveNew, action) => {
        const { timelogStore, commonStore, t } = this.props;
        const { currentEntity } = timelogStore;
        if (saveNew) {
            timelogStore.changeEntity('is_manually_managed', true);
            await timelogStore.save().then(() => {
                this.handleCloseUserPromptModal();
                return this.handleMandatoryCalls(!saveNew, action);
            });
        }
        else {
            try {
                const result = await timelogStore.updateTimesheetToManuallyManagedMode(currentEntity.id, action);
                const overtimeCommentPrompt = result?.userPrompts?.find(ele => ele.source === 'overtimeComment');
                if (overtimeCommentPrompt?.showModal) {
                    this.setState({
                        userPromptModal: {
                            ...overtimeCommentPrompt,
                            actionMethods: {
                                handleSaveOvertimeComment: (comment) => this.saveOvertimeComment(result.timelog.id, comment),
                                handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                            }
                        }
                    });
                }
                return commonStore.addNotification(t(result.message), null, 'success', 'top-right', 5000);
            } catch (err) {
                console.error(err);
                const approvedWeeklyOvertime = err?.response?.body?.userPrompts?.find(ele => ele.source === 'approvedWeeklyOvertime');
                if (approvedWeeklyOvertime?.showModal) {
                    this.setState({
                        userPromptModal: {
                            ...approvedWeeklyOvertime,
                            actionMethods: {
                                handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                                handleResetApprovedWeeklyOvertime: () => this.handleResetApprovedWeeklyOvertime(approvedWeeklyOvertime.sourceInfo.approvedWeeklyOvertime.approvedTimesheets)
                            }
                        }
                    });
                }
            }
        }
    }

    handleManageTimesheetManually = async (reSubmit = false, isFlexitime = false, saveNew = false) => {
        const { timelogStore, commonStore, t } = this.props;
        const { currentEntity } = timelogStore;
        const hasFlexitimeEnabled = commonStore?.config?.client?.data?.basicRules?.timeBankSettings?.allowAutomaticFlexitimeTimeBank && currentEntity.User.allow_auto_flexitime;
        if (!saveNew && !currentEntity?.id)
            return commonStore.addNotification('Missing Params', null, 'warning');
        try {
            if (reSubmit) {
                const message = t("Are you sure you want to change and submit this timesheet for Mandatory") + " " + t(isFlexitime ? 'Flexitime' : 'Overtime') + "?";
                confirmAlert({
                    title: hasFlexitimeEnabled ? t('Mandatory overtime/flexitime') : t('Mandatory overtime'),
                    message: message,
                    buttons: [
                        {
                            label: t('Yes'),
                            onClick: async () => {
                                const mandatoryType = isFlexitime ? 'flexitime' : 'overtime';
                                const result = await timelogStore.updateTimesheetToManuallyManagedMode(currentEntity.id, mandatoryType);
                                commonStore.addNotification(t(result.message), null, 'success', 'top-right', 5000);
                                const overtimeCommentPrompt = result?.userPrompts?.find(ele => ele.source === 'overtimeComment');
                                if (overtimeCommentPrompt?.showModal) {
                                    this.setState({
                                        userPromptModal: {
                                            ...overtimeCommentPrompt,
                                            actionMethods: {
                                                handleSaveOvertimeComment: (comment) => this.saveOvertimeComment(result.timelog.id, comment),
                                                handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                                            }
                                        }
                                    });
                                }
                            },
                        },
                        {
                            label: t('Cancel')
                        }
                    ],
                });
            } else {
                const message = hasFlexitimeEnabled ? "Are you sure you want to add this timesheet as mandatory overtime/flexitime? It's an irreversible change, and the system will validate and remove all automatic calculations"
                    : "Are you sure you want to add this timesheet as mandatory overtime? It's an irreversible change, and the system will validate and remove all automatic calculations";
                confirmAlert({
                    title: hasFlexitimeEnabled ? t('Mandatory overtime/flexitime') : t('Mandatory overtime'),
                    message: t(message),
                    buttons: [
                        {
                            label: t('Add as Overtime'),
                            onClick: async () => {
                                await this.handleMandatoryCalls(saveNew, 'overtime');
                            },
                        },
                        hasFlexitimeEnabled && {
                            label: t('Add as Flexitime'),
                            onClick: async () => {
                                await this.handleMandatoryCalls(saveNew, 'flexitime');
                            },
                        },
                        {
                            label: t('Cancel')
                        }
                    ].filter(Boolean),
                });
            }

        } catch (error) {
            console.error(error);
        }
    }

    fullSave = async (doPublish, skipCheck = {}) => {
        const { timelogStore, commonStore, t } = this.props;
        const { data: clientData } = commonStore.config.client;
        const { currentEntity, originalEntity } = timelogStore;
        const currentOvertimeMode = getOvertimeMode(commonStore.config);

        if ((currentOvertimeMode === overtimeModes.manual || currentEntity.is_manually_managed)
            && currentEntity.total_hours_overall < currentEntity.total_hours_overtime) {
            return commonStore.addNotification(t('Work time is less than overtime'), null, 'error');
        }

        if (currentEntity.tracker_status === 'manual' && currentEntity.break && currentEntity.break >= getShiftTotalTimeBetweenStartAndEnd(getMinutesFromTimeInput(currentEntity.from), getMinutesFromTimeInput(currentEntity.to))) {
            return commonStore.addNotification(t('Break should be less than total hours'), null, 'error');
        }

        const internalSave = () => {
            this.fullSaveInternal(doPublish, skipCheck);
        };

        if (currentEntity.status !== 'draft' && !skipCheck?.skipAbsenceIntersectionCheck) {
            const enableCheck = clientData.basicRules && !clientData.basicRules.allowManualTimelogChange;
            if (enableCheck && currentEntity.tracker_status === 'done' && !currentEntity.is_manually_managed && (currentEntity.from !== originalEntity.from || currentEntity.to !== originalEntity.to)) {
                confirmAlert({
                    title: t('Confirm time change'),
                    message: t('You have changed from/to times, this will switch timesheet to manual'),
                    buttons: [
                        {
                            label: t('Yes, proceed'),
                            onClick: () => {
                                timelogStore.switchToManual();
                                internalSave();
                            },
                        },
                        {
                            label: t('Cancel')
                        },
                    ],
                });
                return;
            }
        }

        if (currentEntity.gps_data?.systemEntry) {
            confirmAlert({
                title: t('Are you sure?'),
                message: t('You are editing auto recorded timesheet, this will switch timesheet to manual'),
                buttons: [
                    {
                        label: t('Yes, proceed'),
                        onClick: () => {
                            timelogStore.changeEntity('changeSystemEntryToManual', true);
                            internalSave();
                        },
                    },
                    {
                        label: t('Cancel')
                    },
                ],
            });
            return;
        }

        internalSave();
    };

    fullSaveInternal = async (doPublish, skipCheck) => {
        const { timelogStore, commonStore, t } = this.props;
        if (doPublish) {
            // this.handleChange('status', 'active');
            this.handleChange('addDistance', doPublish);
        }
        try {
            await timelogStore.save().then(response => {
                this.afterSave(response, doPublish, skipCheck);
            });
        } catch (e) {
            if (e && e.name === 'ValidationError') {
                commonStore.addNotification(t(e.message || 'Error'), null, 'error');
            }
            return;
        }
    };

    handleTimeBankDelete = async (timelog, isDetetingFromCurrentTimelog = false) => {
        const { commonStore, t, timelogStore } = this.props;

        if (!isDetetingFromCurrentTimelog) {
            if (!timelog?.user_id || !timelog?.for_date) {
                return commonStore.addNotification(t('No associated timebank entry found'), null, 'warning');
            }

            const message = (
                <span>
                    {t('As the Overtime from the previously registered timesheet has already been added into the time bank.')}
                    <br />
                    {t('To recalculate correctly, we need to reset the previously added entry. After that, you can manually convert the overtime again.')}
                </span>
            );
            return confirmAlert({
                title: t(`Resolve Conflicts`),
                message,
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: () => {
                            return timelogStore.deleteTimebankAllByDate({ user_id: timelog.user_id, for_date: timelog.for_date }).then((res2) => {
                                commonStore.addNotification(`${t(res2.message)}`, null, 'success');
                                return res2;
                            });
                        },
                    },
                    {
                        label: t('No'),
                        onClick: () => { }
                    },
                ],
            });
        }

        const timeBankEntry = timelog && timelog?.data?.timeBank?.length > 0 ? timelog.data.timeBank[0] : null;
        if (!timeBankEntry) {
            return commonStore.addNotification(t('No associated timebank entry found'), null, 'warning');
        }
        const id = timeBankEntry?.timeBankRequestId;

        confirmAlert({
            title: t(`Are You Sure`),
            message: t('To unlock this timesheet, the associated timebank entry will be reset. Do you want to proceed?'),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        return timelogStore.deleteTimebankAndMakeTimelogsEditable({ time_bank_id: id, deleteAll: true }, true).then((res2) => {
                            commonStore.addNotification(`${t(res2.message)}`, null, 'success');
                            return res2;
                        });
                    },
                },
                {
                    label: t('No'),
                    onClick: () => { }
                },
            ],
        });

    }

    handleChange = (name, value, isAuto = false) => {
        const { timelogStore, commonStore } = this.props;
        let today = moment(new Date()).format('YYYY-MM-DD')
        if (name === 'for_date') {
            this.setState({ isDateChange: moment(value).format('YYYY-MM-DD') < today })
            if (!isAuto && timelogStore.currentEntity.user_id) {
                const isEditMode = !!(this.props.router?.params?.id || this.props.router?.location?.state?.timelogs);
                timelogStore.getUserShiftDetails(timelogStore.currentEntity.user_id, moment(value).format('YYYY-MM-DD'))
                    .then(() => {
                        if (!isEditMode) {
                            const { scheduledShift } = timelogStore;
                            if (!this.hasCompanyShifts && scheduledShift && scheduledShift.start_time != null && scheduledShift.end_time != null) {
                                timelogStore.changeEntity('from', minutesToTimeInput(scheduledShift.start_time));
                                timelogStore.changeEntity('to', minutesToTimeInput(scheduledShift.end_time));
                            } else {
                                const newShiftDetails = getCompanyShiftDetails(commonStore.config, timelogStore.currentEntity.company_shift_id, minutesToTimeInput);
                                timelogStore.changeEntity('from', newShiftDetails.start);
                                timelogStore.changeEntity('to', newShiftDetails.end);
                                timelogStore.changeEntity('break', newShiftDetails.break);
                            }
                        }
                    });
            }
        }
        timelogStore.changeEntity(name, value, null, isAuto);
        timelogStore.changeAutoOvertimeProperties(name, timelogStore.currentEntity, commonStore.config);
    };

    handleCompanyShiftChange = (value) => {
        const { timelogStore, commonStore, t } = this.props;
        try {
            const { currentEntity } = timelogStore;
            const isEditMode = !!(this.props.router?.params?.id || this.props.router?.location?.state?.timelogs);
            const applyShiftChange = () => {
                this.handleChange('company_shift_id', value);
                const data = currentEntity.data ? Object.assign({}, currentEntity.data) : {};
                data.overtimes = {};
                timelogStore.changeEntity('data', data, 'overtime');
                if (currentEntity.is_manually_managed) commonStore.addNotification(t("Working shift updated and overtimes are removed, please add overtimes manually"), null, 'info', 'top-right', 3000);
                this.prepareOvertimeArray();
                this.setState({ isEditingCompanyShift: false });
            };
            if (isEditMode && currentEntity.is_manually_managed) {
                applyShiftChange();
            } else if (isEditMode) {
                const newShiftTimeDetails = getCompanyShiftDetails(commonStore.config, value, minutesToTimeInput);
                const timesChanged = newShiftTimeDetails.start !== currentEntity.from || newShiftTimeDetails.end !== currentEntity.to;
                if (timesChanged) {
                    confirmAlert({
                        title: t('Update Times'),
                        message: t('Update start and end times to match the selected shift?'),
                        buttons: [
                            {
                                label: t('Yes'),
                                onClick: () => {
                                    applyShiftChange();
                                    this.handleChange('from', newShiftTimeDetails.start);
                                    this.handleChange('to', newShiftTimeDetails.end);
                                    this.handleChange('break', newShiftTimeDetails.break);
                                }
                            },
                            {
                                label: t('No'),
                                onClick: () => applyShiftChange()
                            }
                        ]
                    });
                    return;
                }
                applyShiftChange();
            } else {
                const newShiftTimeDetails = getCompanyShiftDetails(commonStore.config, value, minutesToTimeInput);
                applyShiftChange();
                this.handleChange('from', newShiftTimeDetails.start);
                this.handleChange('to', newShiftTimeDetails.end);
                this.handleChange('break', newShiftTimeDetails.break);
            }
        }
        catch (e) {
            console.error(e);
            return commonStore.addNotification(t("Something went wrong"), null, 'error');
        }
    }

    handleChangeOvertimes = (overtime, value) => {
        const { timelogStore, commonStore, t } = this.props;
        try {
            const { currentEntity } = timelogStore;
            const data = currentEntity.data ? Object.assign({}, currentEntity.data) : {};
            data.overtimes = data.overtimes || {};
            const newOvertimes = getOvertimeObject({ ...data.overtimes }, overtime, getMinutesFromTimeInput(value), value);
            data.overtimes = { ...newOvertimes };
            timelogStore.changeEntity('data', data, 'overtime');
        } catch (e) {
            console.error(e);
            return commonStore.addNotification(t("Something went wrong"), null, 'error');
        }
    };

    handleProjectChange = (value, full) => {
        const { timelogStore } = this.props;
        const { currentEntity } = timelogStore;
        this.setState({ previousProjectId: currentEntity.project_id })
        this.handleChange('project_id', value);
    };

    handleTaskChange = (value, full) => {
        const { timelogStore, t, commonStore } = this.props;
        const { currentEntity } = timelogStore;
        if (!parseInt(value) || parseInt(currentEntity.task_id) === parseInt(value)) return;
        if (currentEntity.task_id && parseInt(currentEntity.task_id) !== parseInt(value) && commonStore?.config?.client?.calculate_task_distance_with_company) {
            confirmAlert({
                title: t('Are You Sure'),
                message: t('Updating task in timelog will updated the distance accordingly. Are you sure') + '?',
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: async () => {
                            return this.handleTaskChangeWithDistance(value, full, true);
                        },
                    },
                    {
                        label: t('Cancel'),
                        onClick: () => {
                            if (!this.state.previousProjectId) {
                                this.handleChange('project_id', this.state.previousProjectId);
                                this.setState({ previousProjectId: null })
                            }
                        },
                    }
                ],
            });
        }
        else
            this.handleTaskChangeWithDistance(value, full)

    };

    handleTaskChangeWithDistance = async (value, full, addDistance) => {
        const { timelogStore, taskStore, commonStore } = this.props;
        const { currentEntity } = timelogStore;
        const { config } = commonStore;

        this.handleChange('task_id', value);

        const { task } = await taskStore.load(value);
        this.handleChange('distance_type', task.distance_type);
        if (config.client.calculate_task_distance_with_company
            && task.data && task.data.distance_from_company_location) {
            const distance = task.data && task.data.distance_from_company_location.split(' ')[0];
            this.handleChange('data.distance', distance);
        }

        this.handleChange('data.workplace', task.address);
        if (addDistance) this.handleChange('addDistance', addDistance);
        if (task.start_time && !currentEntity.from) {
            this.handleChange('from', minutesToTimeInput(task.start_time, false));
        }
        if (task.end_time && !currentEntity.to) {
            this.handleChange('to', minutesToTimeInput(task.end_time, false));
        }
        if (task.description) {
            this.handleChange('description', task.description);
        }
        const gpsData = currentEntity.gps_data || {};
        if (task.gps_data) {
            gpsData.task = task.gps_data;
        }
        this.handleChange('gps_data', gpsData);
    }

    intermediateSave = async () => {
        const { timelogStore, commonStore, t } = this.props;
        const { currentEntity } = timelogStore;
        try {
            const result = await timelogStore.save(currentEntity, false, true);
            commonStore.addNotification(result.message || t('Saved'), null, 'success');
        } catch (err) {
            console.error(err);
        }
    };

    handleAbsenceVacationCancelAndProceed = (sourceInfo) => {
        const cancelAbsenceVacationData = sourceInfo.cancelAbsenceVacation;
        return this.props.timelogStore.cancelPendingAbsenceOrVacation(cancelAbsenceVacationData.cancellationLink).then((res) => {
            this.props.commonStore.addNotification(this.props.t(res.message), null, 'success');
            this.timeAction('start');
            this.handleCloseUserPromptModal();
        }).catch((err) => {
            this.props.commonStore.addNotification(this.props.t(err), null, 'error');
        })
    }

    handleRegisterWithMandatory = (mandatoryPrompt) => {
        this.setState({
            userPromptModal: {
                ...mandatoryPrompt,
                showModal: true,
                actionMethods: {
                    handleSubmitMandatoryTimelog: (data) => this.handleSubmitMandatoryTimelogWithBypass(data),
                    handleMandatoryTimelogModalClose: (istypeSaved) => this.handleMandatoryTimelogModalClose(istypeSaved),
                    handleCloseUserPromptModal: (istypeSaved) => this.handleMandatoryTimelogModalClose(istypeSaved)
                }
            }
        });
    }

    handleSubmitMandatoryTimelogWithBypass = async (data) => {
        const { t, commonStore, timelogStore } = this.props;
        try {
            if (!data.type)
                return commonStore.addNotification(t('Please select a mandatory time type'), null, 'warning');
            if (data.type === 'overtime' && !data.overtimeCode)
                return commonStore.addNotification(t('Please select a mandatory overtime type'), null, 'warning');

            timelogStore.changeEntity('is_manually_managed', true);
            const res = await this.timeAction('start');
            await timelogStore.startTimelogAsMandatory(res?.timelog?.id, data);
            commonStore.addNotification(t('Success'), null, 'success');
            this.handleCloseUserPromptModal();
            this.props.router.navigate(`/admin/timelogs/${res?.timelog?.id}`);
        } catch (error) {
            commonStore.addNotification(t(error || 'Error'), null, 'error');
        }
    }

    handleAbsenceVacationCheckAndCancelManually = (sourceInfo, date) => {
        const cancelAbsenceVacationData = sourceInfo.cancelAbsenceVacation;
        const for_date = moment(date).format('YYYY-MM-DD');
        const filters = { fromDate: for_date, fromDate1: new Date(for_date) };
        this.handleCloseUserPromptModal();
        return this.props.router.navigate(`/admin/${cancelAbsenceVacationData.requestType}s`, { state: { filters } });
    }

    handleUserChange = (value, full) => {
        this.handleChange('project_id', null);
        this.handleChange('task_id', null);
        this.handleChange('user_id', value);
        this.handleChange('PM_CHANGE', true);

        this.props.timelogStore.updateTimelogCurrentEntityUser(value);
        const { currentEntity } = this.props.timelogStore;
        if (currentEntity.for_date) {
            this.props.timelogStore.getUserShiftDetails(value, moment(currentEntity.for_date).format('YYYY-MM-DD'))
        }
    };

    async loadData() {
        const { timelogStore, projectStore, taskStore, userStore } = this.props;
        let getId = this.props?.router?.location?.state?.timelogs || this?.props?.router?.params.id || null;
        let finishTimelog = this.props?.router?.location?.state?.finishTimelog || false;
        const { shiftProjectId, shiftTaskId, shiftProjectName, shiftTaskName, shiftTaskNumber, shiftProjectNumber, shiftId } = this.props.router?.location?.state || {};
        const { currentUser } = userStore;
        const { id, user_type } = currentUser;
        let timelog;
        if (getId) {
            timelog = await timelogStore.load(getId);
        } else {
            timelog = await timelogStore.getPossibleDraftTimelog(false);
            if (shiftProjectId && shiftTaskId) {
                timelogStore.changeEntity('project_id', shiftProjectId);
                timelogStore.changeEntity('task_id', shiftTaskId);
            }
        }
        this.handleChange('for_date', timelog.timelog.for_date, true);
        if ((timelog.timelog?.project_id && timelog.timelog?.projectName) || (shiftProjectId && shiftProjectName)) {
            projectStore.prependProjectToLookup({ id: timelog.timelog?.project_id || shiftProjectId, name: timelog.timelog?.projectName || shiftProjectName, project_number: timelog.timelog?.project_number || shiftProjectNumber });
        }
        if ((timelog.timelog?.task_id && timelog.timelog?.taskName) || (shiftTaskId && shiftTaskName)) {
            taskStore.prependTaskToLookup({ id: timelog.timelog?.task_id || shiftTaskId, name: timelog.timelog?.taskName || shiftTaskName, task_number: timelog.timelog?.task_number || shiftTaskNumber })
        }
        const shiftUserId = getId ? timelog.timelog.user_id : id;
        const shiftForDate = moment(timelog.timelog.for_date).format('YYYY-MM-DD');
        if ((getId && timelog.timelog.user_id && timelog.timelog.for_date) || (!getId && user_type !== 'admin')) {
            await timelogStore.getUserShiftDetails(shiftUserId, shiftForDate, getId ? undefined : shiftId, !!getId);
            if (getId) {
                const { data } = timelog.timelog;
                if (data?.shiftId && !timelogStore.canEditCompanyShift) {
                    timelogStore.changeEntity('data.shiftId', null);
                }
            }
        }
        this.prepareOvertimeArray();
        if (this.isOvertimeAutomaticMode && this.timesheetOvertimeTypesArray?.length
            && timelogStore.currentEntity._total_hours_overtime) {
            const ot = getOvertimeObject({},
                this.timesheetOvertimeTypesArray[0],
                timelogStore.currentEntity._total_hours_overtime,
                minutesToTimeInput(timelogStore.currentEntity._total_hours_overtime, false));
            this.setState({ automaticOvertimeObject: ot });
        }

        if (finishTimelog) {
            this.timeAction('finish');
        }
        return null;
    }

    renderCompanyShift = (company_shift_id, dateTimeRules, is_manually_managed, canEditCompanyShift, user_id, for_date) => {
        const { t, commonStore, userStore } = this.props;
        const { isEditingCompanyShift } = this.state;
        const companyShift = commonStore?.config?.companyShifts.find(cs => cs.id === company_shift_id);
        if (!companyShift && !isEditingCompanyShift && is_manually_managed === false) return null;
        // Members can change the shift code only when explicitly allowed via control panel rule
        const allowMemberShiftCodeEdit = commonStore?.config?.client?.data?.basicRules?.allowMembersToChangeTimesheetShiftCode || false;
        const isMemberRestricted = userStore?.currentUser?.user_type === 'member' && !allowMemberShiftCodeEdit;
        const _canEditCompanyShift = !isMemberRestricted && !is_manually_managed && canEditCompanyShift && !!user_id && !!for_date;
        const showSelect = !isMemberRestricted && (is_manually_managed || isEditingCompanyShift);
        return (
            <div className="form-group field field-string mb-4 border-radius-10">
                <label className="control-label">{t('Working Shift')}
                    {companyShift && (
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="company-shift-details-tooltip">
                                    <div style={{ textAlign: 'left' }}>
                                        {renderCompanyShiftDetails(companyShift, t, minutesToTimeInput, timeFormat, dateTimeRules)}
                                    </div>
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1 mt-1" style={{ opacity: '0.5' }} aria-hidden="true" />
                        </OverlayTrigger>
                    )}
                    {_canEditCompanyShift && !isEditingCompanyShift && (
                        <i
                            className="fa fa-edit ms-2 font-size-15 cursor-pointer font-color-primary"
                            aria-hidden="true"
                            onClick={() => this.setState({ isEditingCompanyShift: true })}
                        />
                    )}
                </label>
                {showSelect ?
                    <Select
                        value={companyShift ? { value: companyShift.id, label: companyShift.shift_name } : null}
                        options={commonStore?.config?.companyShifts.map(cs => ({ value: cs.id, label: cs.shift_name }))}
                        onChange={s => this.handleCompanyShiftChange(s.value)}
                    />
                    :
                    <input
                        className="form-control border-radius-10"
                        type="text"
                        value={companyShift ? companyShift.shift_name : ''}
                        disabled={true}
                    />
                }
            </div>
        )
    }

    handleChangeBreakForDisableAutoBreakUser = () => {
        confirmAlert({
            title: this.props.t('Are You Sure'),
            message: this.props.t("Break is disabled in profile. Do you still want to add break?"),
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => {
                        this.props.timelogStore.changeEntity("break", 0, null, false);
                    },
                },
            ],
        })
    }

    handleSaveToTimebank = async () => {
        const { timeBankStore, timelogStore } = this.props;
        const { currentEntity } = timelogStore;
        const payload = { timelog_id: timelogStore?.currentEntity?.id };
        try {
            await timeBankStore.saveTimeBank(payload);
            this.handleCloseUserPromptModal();
            if (currentEntity.tracker_status !== 'manual' && currentEntity.data?.isInjury === undefined) {
                this.checkQuickQuery();
            } else {
                this.getBack();
            }
        }
        catch (e) {
            //error already shown//
        }
    };

    handleResetAndEdit = async () => {
        const { timelogStore, commonStore, t } = this.props;
        const { currentEntity } = timelogStore;
        confirmAlert({
            title: t('Are You Sure'),
            message: t('This action will reset the timelog and allow you to make edits. Do you want to continue?'),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: async () => {
                        try {
                            const result = await timelogStore.validateTimelogAndReset(currentEntity.id);
                            if (result?.success) {
                                commonStore.addNotification(t(result.message || t('Status updated successfully')), null, 'success');
                                this.loadData();
                            }
                        }
                        catch (err) {
                            console.error(err);
                        }
                    },
                },
                {
                    label: t('Cancel')
                }
            ],
        });
    }

    resetMandatoryTimelogToNormalHandler = async (hasMandatoryFlexitime, inDraft) => {
        const { timelogStore, commonStore, t } = this.props;
        const { currentEntity } = timelogStore;
        if (!currentEntity?.id)
            return commonStore.addNotification('Missing Params', null, 'warning');
        const type = t(hasMandatoryFlexitime ? "Flexitime" : "Overtime");
        const message = `${t("Are you sure you want to remove Mandatory")} ${type}?`;
        confirmAlert({
            title: `${t('Remove Mandatory')} ${type}?`,
            message: message,
            buttons: [
                {
                    label: t('Yes'),
                    onClick: async () => {
                        try {
                            const result = await timelogStore.convertMandatoryTimesheetToNormal(currentEntity.id, inDraft);
                            this.loadData();
                            return commonStore.addNotification(t(result.message), null, 'success', 'top-right', 5000);
                        }
                        catch (err) {
                            const intersection = err.response?.body?.userPrompts?.find(ele => ele.source === 'intersection')
                            if (intersection?.showModal) {
                                this.setState({
                                    userPromptModal: {
                                        ...intersection, actionMethods: {
                                            handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                                            handleRegisterWithMandatory: () => this.handleManageTimesheetManually(false, false, true)
                                        }
                                    }
                                });
                            }
                            console.error(err);
                        }
                    }
                },
                {
                    label: t('Cancel')
                }
            ]
        })
    }

    showApproveRejectCommentModal = (full) => {
        const { commonStore } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        this.setState({
            userPromptModal: {
                source: 'adminPmComment',
                header: 'Comment',
                showModal: true,
                sourceInfo: {
                    status: full.status,
                    status_note: full.status_note,
                    status_changed_by: commonStore.getUsername(full.status_changed_by),
                    status_changed_on: shortDateFormat(full.status_changed_on, dateTimeRules)
                },
                actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal }
            }
        });
    }

    render() {
        const { timelogStore, commonStore, t, userStore } = this.props;
        const { loading, updating, currentEntity, timelogShift, scheduledShift, canEditCompanyShift, isShiftLoading } = timelogStore;
        const { data: clientData } = commonStore.config.client;
        const { data: biztypeData } = commonStore.config.biztype;
        const { user_type, id: currentUserId } = userStore.currentUser;
        const { userPromptModal } = this.state;

        if (loading) return <LoadingSpinner />;

        const {
            task_id,
            User,
            user_id,
            from,
            to,
            total_hours_normal,
            total_hours_overtime,
            total_hours_overall,
            data,
            for_date,
            Attachments,
            description,
            status,
            tracker_running,
            _total_hours_normal,
            _total_hours_overtime,
            employeeAssignedForEmergencyShift,
            company_shift_id,
            project_id,
            is_manually_managed,
            status_note,
            overtime_comment,
            isOvertimeCommentMissing,
            showOvertimeComment
        } = currentEntity;
        const { signature } = data;
        const companyShift = getCompanyShiftDetails(commonStore.config, currentEntity.company_shift_id, minutesToTimeInput);

        //mapping data from cp rules//
        const configExtraExpenses = clientData.extendedRules.expense_types || [];
        const configExtraWorks = clientData.extendedRules.extrawork_types || [];
        const quickCheckListText = clientData.basicRules.quickCheckListText || 'Were you injured today at work site?';
        const hideBreakButton = !!(clientData?.basicRules?.hideBreakButton);
        // an exclude normal hours task timesheet can't be mandatory overtime/flexitime
        const isExcludeNormalHoursTask = !!parseInt(task_id) && (clientData.extraPayments || []).some(rule => rule.isActive && rule.excludeNormalHours
            && ((rule.task && parseInt(rule.task) === parseInt(task_id)) || (rule.isMultiTask && Array.isArray(rule.taskIds) && rule.taskIds.map(Number).includes(parseInt(task_id)))));
        const dateTimeRules = clientData && clientData.dateTimeRules ? clientData.dateTimeRules : false;
        const format = dateTimeRules && dateTimeRules.time_format ? dateTimeRules.time_format : 'hh:mm';
        const alloWManualAdd = !(clientData?.loginRules?.autoTimelogs === 'gpsmanual' && user_type === 'member');
        const __extraPaymentRules = getUserExtraPayments(User, clientData.extraPayments, for_date, timelogShift, employeeAssignedForEmergencyShift, parseInt(currentEntity?.task_id ?? 0), commonStore);
        const timelogTaskHasExtraPayment = __extraPaymentRules.some(ele => !ele.hasConfigIssue && ele.task);
        const isSystemEntry = currentEntity?.gps_data?.systemEntry;
        const hasAllowedManagingTimelogsManually = (clientData?.basicRules?.allowManagingTimelogsManually && !isSystemEntry) || false;
        const hasFlexitimeEnabled = commonStore?.config?.client?.data?.basicRules?.timeBankSettings?.allowAutomaticFlexitimeTimeBank && currentEntity?.User?.allow_auto_flexitime;

        //data mapping//
        const configStartTime = companyShift.start;
        const deafultBreakInMins = companyShift.break;
        // TIPS (hidden on frontend, backend module still active):
        // const tipAmount = data.tipInfo && data.tipInfo.amount ? data.tipInfo.amount : '';
        // const tipEditor = clientData.tipRules && clientData.tipRules.tipEditor;
        let overtimes = data?.overtimes || {};
        let weekly_overtimes = data?.weekly_overtimes || {};
        let extraPaymentsInTimeSheet = data?.extraPayments || {};
        // A timesheet that has not been saved yet (no id) is in "add" mode.
        const isAddMode = !currentEntity?.id;
        // Manual inputs (hours/quantity) come from the backend's applicable list, which is only valid for the saved task/date/employee.
        const { applicableManualExtraPaymentTypesFor } = timelogStore;
        const isSavedTaskDateAndUser = !!applicableManualExtraPaymentTypesFor
            && parseInt(applicableManualExtraPaymentTypesFor.task_id) === parseInt(currentEntity.task_id)
            && applicableManualExtraPaymentTypesFor.for_date === moment(currentEntity.for_date).format('YYYY-MM-DD')
            && parseInt(applicableManualExtraPaymentTypesFor.user_id) === parseInt(currentEntity.user_id);
        const applicableManualExtraPaymentTypes = isSavedTaskDateAndUser ? (currentEntity.applicableManualExtraPaymentTypes || []) : [];
        // Show only additional payments that were actually paid (have a calculated value), plus applicable manual inputs;
        const visibleExtraPaymentRules = (__extraPaymentRules || []).filter(
            (ep) => !!extraPaymentsInTimeSheet[ep.code]?.value
                || applicableManualExtraPaymentTypes.some(ele => ele.code === ep.code)
        );
        // Manual payments whose type was changed in the settings after the value was saved: shown read-only in the saved type.
        const typeChangedExtraPaymentCodes = applicableManualExtraPaymentTypes
            .filter(ele => extraPaymentsInTimeSheet[ele.code]?.extraPaymentType?.value
                && extraPaymentsInTimeSheet[ele.code].extraPaymentType.value !== ele.extraPaymentType?.value)
            .map(ele => ele.code);
        // Manual hours (stored as minutes) must not exceed the worked hours (total_hours_overall = start -> end minus break).
        const workedMinutesForExtra = getMinutesFromTimeInput(currentEntity.total_hours_overall);
        const hasInvalidManualExtraPayment = (visibleExtraPaymentRules || []).some((ep) => {
            if (!MANUAL_EXTRA_PAYMENT_TYPES.includes(ep.extraPaymentType?.value)) return false;
            if (typeChangedExtraPaymentCodes.includes(ep.code)) return false;
            const val = extraPaymentsInTimeSheet[ep.code]?.value || 0;
            // Quantity is stored as the point itself; it must be 0 - 1.0.
            if (ep.extraPaymentType?.value === 'manual_point_amount') return val > 1;
            // an exclude normal hours payment can be entered up to the clock time - the break comes off normal hours first and off it
            // once they're used up, and the server pays it up to the worked hours
            return val > workedMinutesForExtra + (ep.excludeNormalHours ? (currentEntity.break || 0) : 0);
        });
        if (Object.keys(this.state.automaticOvertimeObject).length)
            overtimes = this.state.automaticOvertimeObject

        const isTimesheetPublished = status === 'active';
        const timesheetPublishedValidation = t("Timesheet is published. No changes will be accepted for User and Date");
        let isEditDisable = ['approved', 'rejected'].includes(status);
        let validationMessage = isEditDisable ? "Timesheet cannot be updated after approval, Please reset and try again" : null;
        if (!isEditDisable) {
            const timesheetHasTimeBank = timelogStore.validateTimelogifTimeBankPresent({ ...currentEntity }, commonStore.config);
            if (timesheetHasTimeBank) {
                validationMessage = "This timesheet cannot be updated as it contains timebank hours. Please remove the timebank hours and try again.";
                isEditDisable = true;
            }
            if (currentEntity?.gps_data?.systemEntry
                && commonStore?.config?.client?.data?.loginRules?.autoTimelogs === 'autoschedule'
                && (!commonStore?.config?.client?.data?.loginRules?.allowUserToEditAutoTimesheet
                    || (commonStore?.config?.client?.data?.loginRules?.allowUserToEditAutoTimesheet && currentEntity.status === 'draft'))
            ) {
                validationMessage = "This timesheet is auto recorded and cannot be updated directly. To update it, please remove this timesheet and add it manually.";
                isEditDisable = true;
            }
        }

        const isTimesheetHasOtWithAutoFlexitime = data && data.timeBank?.length > 0 && data.timeBank.find(tb => tb.type === 'overtime');
        const hasMandatoryFlexitime = is_manually_managed && data?.mandatoryType === 'flexitime';
        const preventPmSelfApproval = clientData?.basicRules?.preventPmSelfApproval;
        const isOwnRejectedPmTimelog = user_type === 'pm' && currentEntity.user_id === currentUserId && preventPmSelfApproval;
        const showResetAndEdit = status === 'rejected' && (user_type === 'member' || isOwnRejectedPmTimelog);
        const showRejectNote = status === 'rejected' && (user_type === 'admin' || (user_type === 'pm' && currentEntity.user_id !== currentUserId) || showResetAndEdit);

        return (
            <>
                <div className="primary-page" style={{ margin: 0, position: 'relative', maxHeight: '100%' }}>
                    <div className="row justify-content-end mb-2">
                        <div className='col-md-6 col-sm-12'>
                            <h3 className="primary-page__title">
                                {t('Register working hours')}
                                {status === 'draft' && (
                                    <div className="primary-page__title__draft">
                                        <b>{t('This is a draft work log')}</b>
                                    </div>
                                )}
                            </h3>
                        </div>
                        <div className='col-md-6 col-sm-12 d-flex justify-content-end'>
                            {tracker_running &&
                                <div className='d-flex mt-10 me-2'>
                                    <i className="fas fa-ban" style={{ color: "#d93636" }}
                                        title={t('You cannot change the date when worklog is in draft')} />
                                </div>
                            }
                            <div className='customize-datepicker'>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-date">
                                            {tracker_running ? t('You cannot change the date when worklog is in draft') :
                                                isEditDisable ? t(validationMessage) :
                                                    isTimesheetPublished ? t(timesheetPublishedValidation) : t('Select Date')}
                                        </Tooltip>}
                                >
                                    <div>
                                        <DatePicker
                                            selected={new Date(moment(for_date).format('MM/DD/YYYY'))}
                                            onChange={(date) => this.handleChange('for_date', date)}
                                            dateFormat={longDateFormat(dateTimeRules)}
                                            maxDate={new Date()}
                                            bgGrey={true}
                                            disabled={tracker_running || isEditDisable || isTimesheetPublished}
                                        />
                                    </div>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                    <Accordion preExpanded={['time', 'km', 'extrapass', 'otherexp', 'extraw', 'signature', 'final']}>
                        <AccordionItem title={t('Register Time')} uuid="time">
                            {user_type !== 'member' && (
                                <div className="row mb-3 ">
                                    <div className="col-md-6">
                                        <div className="form-group field field-string">
                                            <label className="control-label">{t('Select Member')} *</label>
                                            {this.visualState().allowEditing && (
                                                <OverlayTrigger placement='top' key='selectMember' trigger={['hover', 'focus']} overlay={
                                                    <Tooltip id="tooltip-member">
                                                        {isEditDisable ? t(validationMessage) :
                                                            isTimesheetPublished ? t(timesheetPublishedValidation) : t('Select Member')}
                                                    </Tooltip>}>
                                                    <div>
                                                        <MembersWidget
                                                            className="form-control"
                                                            onChange={(value, full) => this.handleUserChange(value, full)}
                                                            value={user_id}
                                                            defaultIfOne
                                                            style={{ borderRadius: 10 }}
                                                            disabled={isEditDisable || isTimesheetPublished}
                                                        />
                                                    </div>
                                                </OverlayTrigger>
                                            )}
                                            {!this.visualState().allowEditing && User && (
                                                <div>
                                                    {User.first_name} {User.last_name}
                                                </div>
                                            )}
                                            {!this.visualState().allowEditing && !User && (
                                                <div>
                                                    {userStore.currentUser.first_name} {userStore.currentUser.last_name}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group field field-string mb-3">
                                        <label className="control-label">{t('Select Project')} *</label>
                                        <OverlayTrigger placement='top' key='selectProject' trigger={['hover', 'focus']} overlay={
                                            <Tooltip id="tooltip-project">
                                                {isEditDisable ? t(validationMessage) :
                                                    !user_id ? t('Select a member first') :
                                                        t('Select Project')}
                                            </Tooltip>} >
                                            <div>
                                                <ProjectsWidget
                                                    className="form-control"
                                                    onChange={(value) => this.handleProjectChange(value)}
                                                    value={project_id}
                                                    defaultIfOne
                                                    filterByUser={user_id}
                                                    pmMode={userStore.currentUser.user_type === 'pm' ? 'manager' : null}
                                                    disabled={isEditDisable || !user_id}
                                                    isShiftEdit={(project_id && project_id !== 0) ? true : false}
                                                />
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group field field-string mb-3">
                                        <label className="control-label">{t('Select Task')} *</label>
                                        <OverlayTrigger placement='top' key='selectMember' trigger={['hover', 'focus']} overlay={
                                            <Tooltip id="tooltip-task">
                                                {isEditDisable ? t(validationMessage) :
                                                    !user_id ? t('Please select a member first') :
                                                        !project_id ? t('Please select a project first') :
                                                            t('Select Task')}
                                            </Tooltip>} >
                                            <div>
                                                <TasksWidget
                                                    className="form-control"
                                                    onChange={(value, full) => this.handleTaskChange(value, full)}
                                                    value={task_id}
                                                    defaultIfOne
                                                    filterByUser={user_id}
                                                    disabled={isEditDisable || !user_id || !project_id}
                                                    filterByProject={project_id}
                                                    isShiftEdit={(task_id && task_id !== 0) ? true : false}
                                                    defaultByGeneric
                                                />
                                            </div>
                                        </OverlayTrigger>
                                        {timelogTaskHasExtraPayment &&
                                            (<p className='text-danger fw-bold font-size-12'>
                                                {t('Extra payment will be paid for this task, please check Additional payments section for details')}
                                            </p>)}
                                    </div>
                                    <div className="form-group field field-string mb-4 border-radius-10">
                                        <label className="control-label">{t('Workplace')}</label>
                                        <input
                                            className="form-control border-radius-10"
                                            type="text"
                                            value={data.workplace ? (data.workplace === 'null' ? '' : data.workplace) : ''}
                                            placeholder={t('Workplace address')}
                                            onChange={(e) => this.handleChange('data.workplace', e.target.value)}
                                            disabled={isEditDisable}
                                        />
                                    </div>
                                    {isShiftLoading ? <small className="text-muted">{t('Loading shift...')}</small> : this.hasCompanyShifts && this.renderCompanyShift((!!scheduledShift && !this.state.isEditingCompanyShift && !is_manually_managed && !(this.props.router?.params?.id || this.props.router?.location?.state?.timelogs)) ? scheduledShift.company_shift_id : company_shift_id, dateTimeRules, is_manually_managed, canEditCompanyShift, user_id, for_date)}
                                </div>
                                {currentEntity.user_image_attachment_id &&
                                    <div className="col-md-6">
                                        <div style={{ display: 'flex', justifyContent: 'right', height: '160px' }}>
                                            <img
                                                src={getUploadedFileURL(currentEntity.user_image_attachment_id)} alt='user avatar'
                                                style={{ maxHeight: '140px', maxWidth: '200px', marginTop: '0.4rem' }}>
                                            </img>
                                        </div>
                                    </div>
                                }
                            </div>
                            {!!this.visualState().showStartButtons && !!this.visualState().manualDisabled && (
                                <div className="timelog-action-block-new mt-3">
                                    <span className="timelog-action-block-label mb-4">{t('Press "Start" to run timer')}</span>
                                    <div className="timelog-action-block-button">
                                        <Button fill dynamic_lg
                                            onClick={() => this.timeAction('start')}
                                            disabled={this.state.isDateChange}>
                                            <img className='me-2' src={PlayStart} alt='start' />
                                            {t('Start')}
                                        </Button>
                                    </div>
                                </div>
                            )}
                            {!!this.visualState().showStartButtons && !this.visualState().manualDisabled && (
                                <div className="timelog-action-block-new mt-3">
                                    <span className="timelog-action-block-label mb-4">
                                        {t('You can create hours manually or just press "Start" to run timer')}
                                    </span>
                                    <div className="timelog-action-block-button">
                                        <Button fill dynamic_lg
                                            onClick={() => this.timeAction('start')}
                                            disabled={this.state.isDateChange}
                                            title={this.state.isDateChange ? 'You cannot Start working hours for past date' : ''}
                                        >
                                            <div className='d-flex justify-content-center'>
                                                <img className='me-3' src={PlayStart} alt='start' />
                                                {t('Start')}
                                            </div>
                                        </Button>
                                        {alloWManualAdd &&
                                            <Button onClick={() => this.timeAction('manual')} className='timelogs-custom-button-transparent w-100'>
                                                <img className='me-2' src={manuallyIcon} alt='start' />
                                                {t('Manual')}
                                            </Button>
                                        }
                                    </div>
                                </div>
                            )}
                            {!!this.visualState().showFinishButtons && !this.visualState().pauseButtonEnabled && (
                                <div className="timelog-action-block-new mt-3">
                                    <span className="timelog-action-block-label mb-4">{t('Finish the work')}</span>
                                    <div className="timelog-action-block-button">
                                        <Button fill dynamic_lg onClick={() => this.timeAction('finish')}>
                                            <img className='me-2' src={FinishMap} alt='start' />
                                            {t('Finish')}
                                        </Button>
                                    </div>
                                </div>
                            )}
                            {!!this.visualState().showFinishButtons && !!this.visualState().pauseButtonEnabled && (
                                <div className="timelog-action-block-new mt-3">
                                    <span className="timelog-action-block-label mb-4">
                                        {t('You can finish the work or take/end the break')}
                                    </span>
                                    <div className="timelog-action-block-button">
                                        <Button onClick={() => this.timeAction('finish')} fill dynamic_lg>
                                            <img className='me-2' src={FinishMap} alt='start' />
                                            {t('Finish')}
                                        </Button>
                                        {!hideBreakButton &&
                                            <Button wd onClick={() => this.timeAction('break')}>
                                                {currentEntity.tracker_status === 'break'
                                                    ? t('Finish break')
                                                    : t('Start break')}
                                            </Button>
                                        }
                                    </div>
                                </div>
                            )}

                            <Modal
                                backdrop="static"
                                show={this.state.isqucikChecklist}
                                onHide={this.handleQuickChecklistModalClose}>
                                <Modal.Header>
                                    <Modal.Title className="w-100 text-center m-0">{t('Quick Checklist')}</Modal.Title>
                                    <img
                                        src={CloseModalIcon}
                                        alt='closeIcon'
                                        className="cursor-pointer"
                                        onClick={() => this.setState({ accepting: null })}
                                    />
                                </Modal.Header>
                                <Modal.Body>
                                    {t(quickCheckListText)}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => this.handleQuickChecklistModalClose(true)}>
                                        {t('Yes')}
                                    </Button>
                                    <Button variant="secondary" onClick={() => this.handleQuickChecklistModalClose(false)}>
                                        {t('No')}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {currentEntity.task_id && (
                                <>
                                    {!this.visualState().showStartButtons && (
                                        <div className="mt-4">
                                            <div className='row timelog-grid-time-card'>
                                                <Col xs={12} md={6} className='timelog-grid-item-1 justify-content-space-between card-timelog-grid-item'>
                                                    <div className="d-flex align-items-center">
                                                        <i className="timelog-grid__icon">
                                                            <img src={startIcon} alt="Start" />
                                                        </i>
                                                        <span className="timelog-grid__text">{t('Start')}</span>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        {this.visualState().allowTimeEditing && (
                                                            <TimePickerInput
                                                                style={{ width: 150 }}
                                                                value={from}
                                                                format={format === "hh:mm" ? "HH:mm" : format}
                                                                onChange={value => this.handleChange('from', value)}
                                                                className="worklog-input border-radius-10"
                                                                disabled={isEditDisable}
                                                            />
                                                        )}
                                                        {!this.visualState().allowTimeEditing && (
                                                            <span className="timelog-grid__input-text">{from}</span>
                                                        )}
                                                        {from < configStartTime && (
                                                            <i
                                                                className="fa fa-warning ms-2"
                                                                style={{ color: '#FF1E50' }}
                                                                title={t('Starting before') + ' ' + configStartTime}
                                                            />
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={6} className='timelog-grid-item-2 justify-content-space-between card-timelog-grid-item'>
                                                    <div className='d-flex align-items-center'>
                                                        <i className="timelog-grid__icon">
                                                            <img src={endIcon} alt="Stop" />
                                                        </i>
                                                        <span className="timelog-grid__text">{t('End')}</span>
                                                    </div>
                                                    <div className='d-flex align-items-center'>
                                                        {this.visualState().allowTimeEditing && (
                                                            <TimePickerInput
                                                                style={{ width: 150 }}
                                                                value={to}
                                                                format={format === "hh:mm" ? "HH:mm" : format}
                                                                onChange={value => this.handleChange('to', value)}
                                                                className="worklog-input border-radius-10"
                                                                disabled={isEditDisable}
                                                            />
                                                        )}
                                                        {!this.visualState().allowTimeEditing && (
                                                            <span className="timelog-grid__input-text">
                                                                {this.visualState().trackerIsRunning ? t('Still working') : to}
                                                            </span>
                                                        )}
                                                    </div>
                                                </Col>
                                            </div>
                                            <div className='row timelog-grid-time-card'>
                                                <Col xs={12} md={6} className='timelog-grid-item-1 justify-content-space-between align-items-center card-timelog-grid-item'>
                                                    <div>
                                                        <span className="timelog-grid__text ml-30">
                                                            {t('Breaktime')}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        {(currentEntity.break || currentEntity.break === 0) && (
                                                            <InputTime
                                                                value={minutesToTimeInput(currentEntity.break, false)}
                                                                onChange={(e) => {
                                                                    if (!currentEntity.User.auto_break && !currentEntity.break && getMinutesFromTimeInput(e)) {
                                                                        this.handleChangeBreakForDisableAutoBreakUser()
                                                                    }
                                                                    this.handleChange('break', getMinutesFromTimeInput(e))
                                                                }}
                                                                className={`big-input text-center ${currentEntity.break < deafultBreakInMins ? ' dangerTimeInput' : ''}`}
                                                                disabled={hideBreakButton || isEditDisable}
                                                            />
                                                        )}
                                                        {currentEntity.tracker_status === 'break' &&
                                                            currentEntity.data.breakStarted && (
                                                                <span style={{ paddingLeft: 10 }}>
                                                                    {`${t('Break started at')} ${minutesToTimeInput(currentEntity.data.breakStarted, true)}`}
                                                                </span>
                                                            )}
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={6} className='timelog-grid-item-2 justify-content-space-between card-timelog-grid-item'>
                                                    <div className='d-flex align-items-center'>
                                                        <span className="timelog-grid__text ml-30">{t('Total')}</span>
                                                    </div>
                                                    <InputTime disabled value={total_hours_overall} className="big-input text-center" />
                                                </Col>
                                            </div>
                                        </div>
                                    )}
                                    {this.visualState().normalEditing && (
                                        <>
                                            <h3 className="timelog-grid__title">{t('Overtimes')}</h3>
                                            {hasMandatoryFlexitime ? <span className='text-danger'>
                                                {t('This timesheet is submitted as a mandatory flexitime timesheet. Overtimes are not allowed.')}</span>
                                                :
                                                <>
                                                    <div className='font-size-15 mb-2'>
                                                        {(!is_manually_managed && (this.hasCompanyShifts || this.isOvertimeAutomaticMode)) ?
                                                            t('Overtime is calculated automatically according to your agreement.')
                                                            :
                                                            t('Manage Overtimes')
                                                        }
                                                    </div>
                                                    <div className="row timelog-grid-time-card">
                                                        {currentEntity.company_shift_id && !is_manually_managed ?
                                                            <>
                                                                {Object.keys(overtimes || {}).map((ot, index) => (
                                                                    <Col xs={12} md={6} key={`${index}_${overtimes[ot].code}`} className='timelog-grid-overtime-item justify-content-space-between card-timelog-grid-item' >
                                                                        <div className='d-flex align-items-center'>
                                                                            <span className="timelog-grid__text timelog-grid__text-capitalize w-100">
                                                                                {overtimes[ot].name}
                                                                            </span>
                                                                        </div>
                                                                        <OverlayTrigger
                                                                            key={overtimes[ot].name}
                                                                            placement="top"
                                                                            overlay={<Tooltip id="tooltip-top">
                                                                                {isEditDisable ? t(validationMessage) : t(this.visualState().overtimeTooltipMessage)}
                                                                            </Tooltip>}
                                                                        >
                                                                            <div>
                                                                                <InputTime
                                                                                    className="big-input text-center"
                                                                                    value={overtimes[ot].value || '00:00'}
                                                                                    disabled={isEditDisable || !this.visualState().isOvertimeEditable}
                                                                                    onChange={(e) => this.handleChangeOvertimes(overtimes[ot], e)}
                                                                                />
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </Col>
                                                                ))}
                                                            </>
                                                            : this.timesheetOvertimeTypesArray?.length ?
                                                                this.timesheetOvertimeTypesArray.map((overtime, index) => (
                                                                    <Col xs={12} md={6}
                                                                        key={`${index}_${overtime.code}`}
                                                                        className='timelog-grid-overtime-item justify-content-space-between card-timelog-grid-item'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <span className="timelog-grid__text timelog-grid__text-capitalize w-100">
                                                                                {overtime.name}
                                                                            </span>
                                                                        </div>
                                                                        <OverlayTrigger
                                                                            key={overtime.name}
                                                                            placement="top"
                                                                            overlay={<Tooltip id="tooltip-top">
                                                                                {isEditDisable ? t(validationMessage) : t(this.visualState().overtimeTooltipMessage)}
                                                                            </Tooltip>}
                                                                        >
                                                                            <div>
                                                                                <InputTime
                                                                                    className="big-input text-center"
                                                                                    value={
                                                                                        overtimes[overtime.code]
                                                                                            ? overtimes[overtime.code].value
                                                                                            : '00:00'
                                                                                    }
                                                                                    disabled={isEditDisable || !this.visualState().isOvertimeEditable}
                                                                                    onChange={(e) => this.handleChangeOvertimes(overtime, e)}
                                                                                />
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </Col>
                                                                ))
                                                                :
                                                                <div className='d-flex align-items-center'>
                                                                    <span className="timelog-grid__text timelog-grid__text-capitalize w-100">
                                                                        {t('Overtime configuration not found, please contact administrator')}
                                                                    </span>
                                                                </div>
                                                        }
                                                    </div>
                                                </>
                                            }
                                        </>
                                    )}
                                    {this.visualState().normalEditing && !!Object.keys(weekly_overtimes || {}).length && (
                                        <>
                                            <h3 className="timelog-grid__title">{t('Weekly Overtimes')}</h3>
                                            <div className="row timelog-grid-time-card">
                                                {Object.keys(weekly_overtimes).map((wot, index) => (
                                                    <Col xs={12} md={6} key={`${index}_${weekly_overtimes[wot].code}`} className='timelog-grid-overtime-item justify-content-space-between card-timelog-grid-item'>
                                                        <div className='d-flex align-items-center'>
                                                            <span className="timelog-grid__text timelog-grid__text-capitalize w-100">
                                                                {weekly_overtimes[wot].name}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <InputTime
                                                                className="big-input text-center"
                                                                value={weekly_overtimes[wot].value || '00:00'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </Col>
                                                ))}
                                            </div>
                                        </>
                                    )}

                                    {this.visualState().normalEditing && showOvertimeComment && !this.visualState().trackerIsRunning && (
                                        <>
                                            <h3 className="timelog-grid__title">
                                                {t('Overtime Comment')}
                                                {isOvertimeCommentMissing && !overtime_comment &&
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id="tooltip-top">
                                                                {t('Comment for overtime is missing')}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-triangle text-warning ms-2" aria-hidden="true"></i>
                                                    </OverlayTrigger>
                                                }
                                            </h3>
                                            <div className="row timelog-grid-time-card">
                                                <Col xs={12}>
                                                    <Textarea
                                                        className={'overtime-comment-box'}
                                                        value={overtime_comment || ''}
                                                        style={{ width: '100%' }}
                                                        onChange={(e) => this.handleChange('overtime_comment', e.target.value)}
                                                        placeholder={t('Add comment for overtime')}
                                                        disabled={isEditDisable || !isTimesheetPublished}
                                                    />
                                                </Col>
                                            </div>
                                        </>
                                    )}
                                    {this.visualState().normalEditing && !this.visualState().trackerIsRunning && (
                                        <>
                                            <h3 className="timelog-grid__title">{t('Additional Payments')}</h3>
                                            {is_manually_managed ?
                                                <span className='text-danger'>{hasFlexitimeEnabled ? t('Additional payments are not calculated for timesheets with mandatory overtime/flexitime')
                                                    : t('Additional payments are not calculated for timesheets with mandatory overtime')}</span>
                                                :
                                                <>
                                                    <div className='font-size-15 mb-2'>
                                                        {(!isAddMode && !visibleExtraPaymentRules?.length)
                                                            ? t('No additional payments apply to this timesheet')
                                                            : t("Fixed additional payments are added automatically according to your agreement.")}.
                                                    </div>
                                                    {!!visibleExtraPaymentRules?.length &&
                                                        <div className="row timelog-grid-time-card">
                                                            {visibleExtraPaymentRules?.map((extraPayment, index) => (
                                                                <Col key={`${index}_${extraPayment.code}`}
                                                                    xs={12} md={6}
                                                                    className='timelog-grid-extra-payment-item justify-content-space-between card-timelog-grid-item'>
                                                                    <div className='d-flex align-items-center'>
                                                                        <span className="timelog-grid__text timelog-grid__text-capitalize w-100"
                                                                            title={extraPayment.description ? extraPayment.description : extraPayment.name}>
                                                                            {extraPayment.name}
                                                                        </span>
                                                                        {(extraPayment.hasConfigIssue || typeChangedExtraPaymentCodes.includes(extraPayment.code)) &&
                                                                            <OverlayTrigger
                                                                                key={`configIssue${extraPayment.code}`}
                                                                                placement='bottom'
                                                                                overlay={<Tooltip id={`config_issue_tool_tip${extraPayment.code}`}>
                                                                                    {typeChangedExtraPaymentCodes.includes(extraPayment.code)
                                                                                        ? t('The type of this additional payment has been changed in the settings. Please save the timesheet.')
                                                                                        : t(extraPayment.configIssueText)}
                                                                                </Tooltip>}
                                                                            >
                                                                                <i className='fa fa-exclamation-circle text-danger ms-2' />
                                                                            </OverlayTrigger>
                                                                        }
                                                                    </div>
                                                                    <OverlayTrigger
                                                                        key={extraPayment.code}
                                                                        placement="top"
                                                                        overlay={<Tooltip id={`tool_tip_${extraPayment.code}`}>
                                                                            {typeChangedExtraPaymentCodes.includes(extraPayment.code)
                                                                                ? t('The type of this additional payment has been changed in the settings. Please save the timesheet.')
                                                                                : extraPayment.hasConfigIssue ? t(extraPayment.configIssueText) : t(extraPayment.helpText)}</Tooltip>}
                                                                    >
                                                                        <div className='d-flex align-items-center'>
                                                                            {/* Input format follows the saved entry's type when there is one (it may differ from the rule after a type change). */}
                                                                            {(extraPaymentsInTimeSheet[extraPayment.code]?.extraPaymentType?.value || extraPayment?.extraPaymentType?.value) === 'manual_point_amount' ?
                                                                                // Quantity entry: the point itself, 0-1.0.
                                                                                <NumberInput
                                                                                    style={{ maxWidth: '85px' }}
                                                                                    customClassses="text-center"
                                                                                    step="0.01"
                                                                                    min={0}
                                                                                    max={1}
                                                                                    disabled={!extraPayment.isEditable || isEditDisable || typeChangedExtraPaymentCodes.includes(extraPayment.code)}
                                                                                    value={extraPaymentsInTimeSheet[extraPayment.code] ?
                                                                                        extraPaymentsInTimeSheet[extraPayment.code].value
                                                                                        : 0}
                                                                                    onFocus={(e) => e.target.select()}
                                                                                    onChange={(e) => {
                                                                                        const decimals = e.target.value.split('.')[1];
                                                                                        if (decimals && decimals.length > 2) return;
                                                                                        timelogStore.handleChangeExtraPayments(extraPayment, e.target.value);
                                                                                    }}
                                                                                />
                                                                                : (extraPaymentsInTimeSheet[extraPayment.code]?.extraPaymentType?.value || extraPayment?.extraPaymentType?.value) === 'fixed_hourly_amount' ?
                                                                                    <NumberInput
                                                                                        style={{ maxWidth: '85px' }}
                                                                                        customClassses="text-center"
                                                                                        disabled={!extraPayment.isEditable || isEditDisable}
                                                                                        value={extraPaymentsInTimeSheet[extraPayment.code] ?
                                                                                            extraPaymentsInTimeSheet[extraPayment.code].value
                                                                                            : 0}
                                                                                    />
                                                                                    :
                                                                                    <InputTime
                                                                                        disabled={!extraPayment.isEditable || isEditDisable || typeChangedExtraPaymentCodes.includes(extraPayment.code)}
                                                                                        value={extraPaymentsInTimeSheet[extraPayment.code] ?
                                                                                            minutesToTimeInput(extraPaymentsInTimeSheet[extraPayment.code].value)
                                                                                            : '00:00'
                                                                                        }
                                                                                        className="big-input text-center"
                                                                                        onChange={(e) => timelogStore.handleChangeExtraPayments(extraPayment, e)}
                                                                                    />
                                                                            }
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                </Col>
                                                            ))}
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </>
                                    )}
                                    {/* TIPS (hidden on frontend, backend module still active):
                                    this.visualState().normalEditing && (tipEditor === "member") && (
                                        <>
                                            <h3 className="timelog-grid__title">{t('Tip Entry')}</h3>
                                            <div className="timelog-grid-time-card">
                                                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='timelog-grid-overtime-item justify-content-space-between card-timelog-grid-item'>
                                                    <span className="timelog-grid__text timelog-grid__text-capitalize d-flex align-items-center" style={{ flex: 1 }}>
                                                        {t("Tip Amount")}
                                                    </span>
                                                    <NumberInput
                                                        className="timelog-tip-entry"
                                                        value={tipAmount}
                                                        onChange={(evt) => { this.handleChange('data.tipInfo.amount', evt.target.value) }}
                                                        disabled={isEditDisable}
                                                    />
                                                </Col>
                                            </div>
                                        </>
                                    )
                                    */}
                                </>
                            )}
                        </AccordionItem>
                        {!biztypeData.timelog_hide_kilometers && this.visualState().normalEditing && (
                            <AccordionItem title={t('Register Distance')} uuid="km">
                                <div className="register-dist">
                                    <div className="register-dist__main-input">
                                        <img src={distanceIcon} alt="Distance" />
                                        <div>
                                            <NumberInput
                                                className="timelog-tip-entry"
                                                value={data.distance}
                                                onChange={(e) => this.handleChange('data.distance', e.target.value)}
                                                disabled={isEditDisable}
                                            />
                                            <span className='ms-3'>{distanceUnitType(dateTimeRules)}</span>
                                        </div>
                                    </div>
                                    <div className="register-dist__inputs">
                                        <Col xs={12} md={6} >
                                            <Input
                                                label={t('Workplace 1')}
                                                className="register-dist__input w-100 timelog-array-custom-margin"
                                                value={data.address}
                                                onChange={(e) => this.handleChange('data.address', e.target.value)}
                                                placeholder={t('Address')}
                                                disabled={isEditDisable}
                                            />
                                        </Col>
                                        <Col xs={12} md={6} >
                                            <Input
                                                label={t('Workplace 2')}
                                                className="register-dist__input w-100 timelog-array-custom-margin"
                                                value={data.workplace}
                                                onChange={(e) => this.handleChange('data.workplace', e.target.value)}
                                                placeholder={t('Address')}
                                                disabled={isEditDisable}
                                            />
                                        </Col>
                                    </div>
                                </div>
                            </AccordionItem>
                        )}
                        {!biztypeData.timelog_hide_kilometers && this.visualState().normalEditing && (
                            <AccordionItem title={t('Extra Passangers')} uuid="extrapass">
                                <DynamicList
                                    placeholder={t('Enter passanger name')}
                                    label={t('Passanger Name')}
                                    onItemsChange={(passangers) => this.handleChange('data.passangers', passangers)}
                                    initData={data.passangers}
                                    disabled={isEditDisable}
                                />
                            </AccordionItem>
                        )}
                        {!biztypeData.timelog_hide_other && this.visualState().normalEditing && (
                            <AccordionItem title={t('Other Expenses')} uuid="otherexp">
                                <TimelogArray
                                    mode="expenses"
                                    options={configExtraExpenses}
                                    onSave={(expenses) => this.handleChange('data.expenses', expenses)}
                                    initData={data.expenses}
                                    disabled={isEditDisable}
                                />
                            </AccordionItem>
                        )}
                        {!biztypeData.timelog_hide_extra && this.visualState().normalEditing && (
                            <AccordionItem title={t('Extra Work')} uuid="extraw">
                                <TimelogArray
                                    mode="work"
                                    options={configExtraWorks}
                                    onSave={(extraWork) => this.handleChange('data.extraWork', extraWork)}
                                    initData={data.extraWork}
                                    disabled={isEditDisable}
                                />
                            </AccordionItem>
                        )}
                        {this.visualState().normalEditing && (
                            <AccordionItem title={t('Signature')}>
                                <Signature
                                    onChange={(signature) => this.handleChange('data.signature', signature)}
                                    initialSignature={signature}
                                    required
                                    width="100%"
                                    height={250}
                                    error={false && !signature}
                                />
                            </AccordionItem>
                        )}
                        {this.visualState().normalEditing && (
                            <AccordionItem title={t('Final Step')} uuid="final">
                                <div className="timelog-final">
                                    <div className="timelog-final__item">
                                        <h4 className="timelog-grid__title mt-0">{t('Other Documents')}</h4>
                                        <div className='d-flex w-100 attachment-box'>
                                            <AttachmentsWidget
                                                value={data.attachments}
                                                onChange={(attachIds) => this.handleChange('data.attachments', attachIds)}
                                                options={{
                                                    checkDate: true,
                                                    imageContext: {
                                                        existingAttachment: Attachments,
                                                        fileType: 'docs',
                                                        id: 0,
                                                        model: 'Timelog',
                                                    },
                                                }}
                                                disabled={isEditDisable}
                                            />
                                        </div>
                                    </div>
                                    <div className="timelog-final__item">
                                        <Textarea
                                            label={t('Comment') + ('*')}
                                            value={description}
                                            style={{ width: '100%' }}
                                            onChange={(e) => this.handleChange('description', e.target.value)}
                                            placeholder={t('Enter comments here')}
                                            disabled={isEditDisable}
                                        />
                                    </div>
                                    <div className="timelog-final__item">
                                        <div className='row timelog-grid-time-card'>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='timelog-grid-item-1 justify-content-space-between card-timelog-grid-item p-3 align-items-center'>
                                                {t('Working hours')}: <br />
                                                <InputTime className='timelog-final-time-card' disabled value={_total_hours_normal ? minutesToTimeInput(_total_hours_normal, false) : total_hours_normal} onChange={() => { }} />
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='timelog-grid-item-2 justify-content-space-between card-timelog-grid-item p-3 align-items-center'>
                                                {t('Overtime hours')}: <br />
                                                <InputTime className='timelog-final-time-card' disabled value={_total_hours_overtime ? minutesToTimeInput(_total_hours_overtime, false) : total_hours_overtime} onChange={() => { }} />
                                            </Col>
                                        </div>
                                    </div>
                                </div>
                            </AccordionItem>
                        )}
                    </Accordion>
                    {this.visualState().normalEditing && this.visualState().allowSave && currentEntity.status === 'draft' && (
                        <div className='timelog-save-buttons'>
                            {hasAllowedManagingTimelogsManually && is_manually_managed &&
                                <div className='d-flex justify-content-start'>
                                    <span className='text-danger fw-bold font-size-12'>
                                        {t("Timesheet is registered for manadatory overtime/flexitime")}.
                                    </span>
                                </div>
                            }
                            <div className={`d-flex ${is_manually_managed ? 'justify-content-space-between' : 'justify-content-end'}`}>
                                {hasAllowedManagingTimelogsManually && is_manually_managed &&
                                    <div>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-convert-normal">
                                                    {t('Click and remove to convert it back to regular timesheet')}.
                                                </Tooltip>
                                            }
                                        >
                                            <span className="d-inline-block">
                                                <Button ms2 fill
                                                    warning
                                                    dynamic_lg
                                                    disabled={isEditDisable}
                                                    onClick={() => this.resetMandatoryTimelogToNormalHandler(hasMandatoryFlexitime, true)}>
                                                    {t('Remove Mandatory') + " " + t(hasMandatoryFlexitime ? "Flexitime" : "Overtime")}
                                                </Button>
                                            </span>
                                        </OverlayTrigger>
                                    </div>
                                }
                                <div>
                                    {!!this.visualState().showFinishButtons && !this.visualState().pauseButtonEnabled && (
                                        <>
                                            <OverlayTrigger placement='top' overlay={
                                                <Tooltip id="tooltip-top">{t('Finish the work')}</Tooltip>}
                                            >
                                                <Button fill dynamic_lg me2
                                                    onClick={() => this.timeAction('finish')}>
                                                    <img className='me-2' src={FinishMap} alt='finish' />
                                                    {t('Finish')}
                                                </Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement='top' overlay={
                                                <Tooltip id="tooltip-top">{isEditDisable ?
                                                    t(validationMessage) : hasInvalidManualExtraPayment ?
                                                        t('Additional payment hours cannot exceed the worked hours (start time to end time)') : t('Save as draft')}</Tooltip>}
                                            >
                                                <Button
                                                    fill dynamic_lg btn_mute me2
                                                    onClick={() => this.intermediateSave()}
                                                    disabled={isEditDisable || updating || hasInvalidManualExtraPayment}
                                                >
                                                    {t('Save as draft')}
                                                </Button>
                                            </OverlayTrigger>
                                        </>
                                    )}

                                    {!this.visualState().trackerIsRunning && (
                                        <OverlayTrigger placement='top' overlay={
                                            <Tooltip id="tooltip-top">{isEditDisable ?
                                                t(validationMessage) : hasInvalidManualExtraPayment ?
                                                    t('Additional payment hours cannot exceed the worked hours (start time to end time)') : t('Save and publish')}</Tooltip>}
                                        >
                                            <Button
                                                fill dynamic_lg
                                                onClick={() => this.fullSave(true)}
                                                disabled={isEditDisable || updating || hasInvalidManualExtraPayment}
                                            >
                                                {t('Save and publish')}
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                    <Button
                                        fill dynamic_lg
                                        onClick={() => this.getBack()}
                                        className="mx-2"
                                    >
                                        {t('Back to list')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                    {this.visualState().normalEditing && this.visualState().allowSave && currentEntity.status !== 'draft' && (
                        <div className='timelog-save-buttons'>
                            <div className={`d-flex justify-content-space-between align-items-end`}>
                                {
                                    (status === 'approved' || status === 'rejected') ?
                                        (
                                            <div style={{
                                                padding: '4px 10px',
                                                borderRadius: '8px',
                                                border: `1px solid ${status === 'approved' ? '#198754' : '#dc3545'}`,
                                                color: status === 'approved' ? '#0a3622' : '#58151c',
                                                backgroundColor: status === 'approved' ? '#d1e7dd' : '#f8d7da',
                                            }}>
                                                <span>
                                                    <span className='text-capitalize fw-bold'>{t(status)} </span>
                                                    <span style={{
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                    }} onClick={() => this.showApproveRejectCommentModal(currentEntity)}>{t('View Comment')}</span>
                                                </span>
                                            </div>

                                        ) :
                                        (
                                            <div>
                                                {hasAllowedManagingTimelogsManually && is_manually_managed &&
                                                    <div className='d-flex justify-content-start'>
                                                        <span className='text-danger fw-bold font-size-12'>
                                                            {hasFlexitimeEnabled ? t("Mandatory overtime/flexitime, please verify hours before saving") : t("Mandatory overtime, please verify hours before saving")}
                                                        </span>
                                                    </div>
                                                }
                                                {hasAllowedManagingTimelogsManually &&
                                                    <div>
                                                        {is_manually_managed ?
                                                            <>
                                                                {
                                                                    !isExcludeNormalHoursTask && !data?.isExcludeNormalHoursTask && (hasMandatoryFlexitime ?
                                                                        <Button
                                                                            fill dynamic_lg
                                                                            success
                                                                            onClick={() => this.handleManageTimesheetManually(true, !hasMandatoryFlexitime)}
                                                                            disabled={isEditDisable}
                                                                        >
                                                                            {t('Update to Mandatory') + ' ' + t('Overtime')}
                                                                        </Button>
                                                                        :
                                                                        hasFlexitimeEnabled &&
                                                                        <Button
                                                                            fill dynamic_lg
                                                                            success
                                                                            onClick={() => this.handleManageTimesheetManually(true, !hasMandatoryFlexitime)}
                                                                            disabled={isEditDisable}
                                                                        >
                                                                            {t('Update to Mandatory') + ' ' + t('Flexitime')}
                                                                        </Button>)
                                                                }
                                                                <Button
                                                                    ms2
                                                                    warning
                                                                    fill dynamic_lg
                                                                    onClick={() => this.resetMandatoryTimelogToNormalHandler(hasMandatoryFlexitime, false)}
                                                                    disabled={isEditDisable}
                                                                >
                                                                    {t('Remove Mandatory') + ' ' + t(hasMandatoryFlexitime ? 'Flexitime' : 'Overtime')}
                                                                </Button>
                                                            </>
                                                            :
                                                            !isExcludeNormalHoursTask && !data?.isExcludeNormalHoursTask &&
                                                            <OverlayTrigger placement='top' overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    {data?.isAdminManagedOvertime ? hasFlexitimeEnabled ? t('Urgent work timesheets cannot be used for mandatory overtime/flexitime') : t('Urgent work timesheets cannot be used for mandatory overtime')
                                                                        : validationMessage || (hasFlexitimeEnabled ? t('Mandatory overtime/flexitime can be used for timesheet after regular work, work on holidays, or unscheduled work') : t('Mandatory overtime can be used for timesheet after regular work, work on holidays, or unscheduled work'))}
                                                                </Tooltip>}
                                                            >
                                                                <Button
                                                                    fill dynamic_lg
                                                                    onClick={() => {
                                                                        this.handleManageTimesheetManually(false, false)
                                                                    }}
                                                                    disabled={isEditDisable || data?.isAdminManagedOvertime}
                                                                >
                                                                    {hasFlexitimeEnabled ? t('Mandatory overtime/flexitime') : t('Mandatory overtime')}
                                                                </Button>
                                                            </OverlayTrigger>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        )
                                }

                                <div>
                                    {isTimesheetHasOtWithAutoFlexitime &&
                                        <Button
                                            fill dynamic_lg me2
                                            onClick={() => this.handleTimeBankDelete(timelogStore.currentEntity, true)}
                                        >
                                            {t('Clear Timebank & Edit')}
                                        </Button>
                                    }
                                    {showResetAndEdit ? (
                                        <Button wd fill style={{ backgroundColor: 'darkorange', borderColor: 'darkorange' }} className="mx-2 text-white" onClick={() => this.handleResetAndEdit()}>
                                            {`${t('Reset')} & ${t('Edit')}`}
                                        </Button>
                                    ) :
                                        <OverlayTrigger placement='top' overlay={
                                            <Tooltip id="tooltip-top">{isEditDisable ?
                                                t(validationMessage) : hasInvalidManualExtraPayment ?
                                                    t('Additional payment hours cannot exceed the worked hours (start time to end time)') : t('Save')}</Tooltip>}
                                        >
                                            <Button
                                                fill dynamic_lg me2
                                                onClick={() => this.fullSave(false)}
                                                disabled={isEditDisable || updating || hasInvalidManualExtraPayment}
                                            >
                                                {t('Save')}
                                            </Button>
                                        </OverlayTrigger>
                                    }
                                    <Button
                                        fill dynamic_lg
                                        className="mx-2"
                                        onClick={() => this.getBack()}
                                    >
                                        {t('Back to list')}
                                    </Button>
                                </div>
                            </div>
                            {showRejectNote &&
                                <div className='text-danger mt-1'>
                                    {`${t('Note')}: ${t('Overtimes and Timebank hours are removed as this timesheet was rejected, on reset it will be added automatically if applicable')}`}
                                </div>
                            }
                        </div>
                    )}

                    <UserPromptModal
                        source={userPromptModal.source}
                        header={userPromptModal.header}
                        showModal={userPromptModal.showModal}
                        sourceInfo={userPromptModal.sourceInfo}
                        actions={userPromptModal.actions}
                        actionMethods={userPromptModal.actionMethods}
                    />
                </div >
            </>
        );
    }
}

export default inject('timelogStore', 'commonStore', 'userStore', 'taskStore', 'timeBankStore', 'projectStore')(applicationRouter(withLocalization(observer(TimelogsForm))));
